<template>
  <div :class="modalMode ? 'details-in-modal task-details-in-modal' : 'mb-5 mx-5 mt-3'">
    <div class="mb-1" v-if="!modalMode">
      <breadCrumbs
        :routesArray="routesArray"
      ></breadCrumbs>
    </div>
                      
    <div class="flex-shrink-0">
      <div class="flex flex-row justify-between items-center">
        <div class="items-center justify-between flex" v-if="!modalMode">
          <div class="title flex items-center">
            <h1 :class="titleLength > 40? 'table-ellipsis':''">{{ presentFindingObject.finding }}</h1>
          </div>
        </div>
        <div v-else></div>
        <!-- <div class="flex flex-row" v-if="approvalObj.statusCode == 10401">
          <button
            class="btnprimary items-center btnPrimaryPadding mr-2"
            @click="approveOrReject(10403)"
          >
            Approve
          </button>
          <button
            class="btnprimary items-center btnPrimaryPadding"
            @click="approveOrReject(10410)"
          >
            Reject
          </button>
        </div> -->
        <div class="flex flex-row" v-if="approvalObj.statusCode == 10401 && checkReviewer(presentFindingObject.reviewer)">
          <button class="btnprimary items-center btnPrimaryPadding mr-2" @click="approveOrReject(10403)" :disabled="clickOnButtonToReject">Approve</button>
          <button class="btnprimary items-center btnPrimaryPadding" @click="showPopupToReject()">Reject</button>
      </div>
      </div>
      <!-- <div class="mt-3">
        <p class="headerText">
          An IT Compliance or information technology Compliance is an
          investigation and evaluation of IT systems, infrastructures, policies,
          and operations. Through IT Compliances, a company can determine if the
          messing T controls protect corporate assets, ensure data integrity and
          align with the organization's business and financial controls.
        </p>
      </div> -->
    </div>
    <div class="w-full minheight">
      <div class="w-full">
        <div class="text-sm">
          <div class="mainContainer tabStructure flex flex-row w-full bg-white border rounded-sm mt-5 px-5 pr-5 pb-3 pt-5 border-lightgrey">
            <Tabs v-model:value="selectedTabIndex" scrollable class="w-80 pr-5">
              <div>
              <TabList >
                    <Tab v-for="(tab) in tabHead" :key="tab.id" :value="tab.id" @click="toggleTabs(tab)">
                        {{ tab.displayName }}
                    </Tab>
                </TabList>
              </div>
                <TabPanels class="overflow-auto  hide-scrollbar">
                  <TabPanel v-for="(tab) in tabHead" :key="tab.id" :value="tab.id">
                    <!-- {{tab.id}}{{tab}} -->
                      <div class="h-full min-h-0">
                      <div class="overflow-y-auto descriptionToggle" v-if="tab.id == 1">
                  <div>
                  </div>
                    <div
                      class="border-b border-lightgrey flex justify-between pb-2 mb-5"
                    >
                      <div class="flex items-center justify-center">
                        <div>
                          <p class="header margining">Finding Information</p>
                        </div>
                      </div>
                      <div>
                        <!-- <div
                          class="buttonposition flex justify-center items-center"
                        >
                          <div
                            class="buttonposition flex justify-center items-center" @click="routeToTask()"
                          >
                            <button class='filterButton' >
                              View Task
                            </button>
                        </div>
                      </div> -->
                    </div>
                  </div>
                <div v-if="tabDataLoading == true">
                  <div class="flex items-center justify-center w-full h-16 skeleton">
								    <dots-loader/>
                  </div>
                </div>
                  <div  v-else>
                    <!-- <div v-for="(obj, index) in presentFindingObject" :key="index" class="mt-3">{{ obj }} -->
                    <div class="flex flex-row">
                      <div
                        class="border-t border-l border-b p-2 header w-1/4 border-lightgrey rounded-tl-md"
                      >
                        Finding ID
                      </div>
                      <div
                        class="border-t border-b border-l p-2 header borderwidth w-1/3 border-lightgrey text-sm"
                      >
                        {{ String(presentFindingObject.findingId).toUpperCase() }}
                      </div>
                      <div
                        class="border-t border-b border-l p-2 header w-1/4 border-lightgrey"
                      >
                        CR ID
                      </div>
                      <div
                        class="border p-2 header w-1/4 border-lightgrey rounded-tr-md text-sm"
                      >
                        {{
                            presentFindingObject?.complianceDetails?.[0]?.crId != null
                              ? String(presentFindingObject.complianceDetails[0].crId).toUpperCase()
                              : 'N/A'
                        }}
                      </div>
                    </div>
                    <!-- <div class="w-full flex flex-row">
                      <div
                        class="border-l w-23 border-b p-2 header border-lightgrey"
                      >
                        Framework
                      </div>
                      <div
                        class="w-27 border-b border-l border-lightgrey text-sm p-2"
                      >
                        {{ presentFindingObject.frameworks }}
                      </div>
                      <div
                        class="border-l w-23 border-b p-2 header border-lightgrey"
                      >
                        Control Number
                      </div>
                      <div
                        class="border-r w-27 border-b border-l border-lightgrey p-2"
                      >
                        <div class="pl-3 flex items-center flex-wrap">
                          <div
                            :class="getBorder()"
                            class="text-xs px-2 py-0.5 font-opensans bg-white font-bold h-auto w-fit flex items-center"
                          >
                            {{ presentFindingObject.frameWorkControl }}
                          </div>
                        </div>
                      </div>
                    </div> -->
                    <div class="flex flex-row">
                      <div
                        class="border-l border-b p-2 header w-1/4 border-lightgrey"
                      >
                        {{ getFindingRelatedToFieldLabel(presentFindingObject) }}
                      </div>
                      <div
                        class="border-b border-l p-2 borderwidth w-1/3 border-lightgrey text-xs"
                      >
                        {{ getFindingRelatedToDisplay(presentFindingObject) }}
                      </div>
                      <div
                        class="border-b border-l p-2 header w-1/4 border-lightgrey"
                      >
                        {{ getFindingLinkFieldLabel(presentFindingObject) }}
                      </div>
                      <div
                        class="border-r border-b border-l border-lightgrey w-1/4 text-xs p-2"
                      >
                        {{ getFindingLinkDisplay(presentFindingObject) }}
                      </div>
                    </div>
                    <div class="flex flex-row">
                      <div
                        class="border-l border-b p-2 header w-23 border-lightgrey"
                      >
                        Finding
                      </div>
                      <div
                        class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify"
                      >
                        {{ presentFindingObject.finding }}
                      </div>
                    </div>
                    <div class="flex flex-row">
                      <div
                        class="border-l border-b p-2 header w-23 border-lightgrey flex items-center"
                      >
                        Evidence
                      </div>
                      <div
                        class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify"
                      >
                          <div v-if="findingFileEvidences.length || findingLinkEvidences.length" class="flex gap-3 flex-wrap">
                          <div v-for="(doc, idx) in findingFileEvidences" :key="'finding-file-'+idx">
                              <div class="pdf w-full rounded-sm">
                                  <a
                                    href="#"
                                    @click.prevent="openEvidenceFile(doc)"
                                    class="flex w-full flex-row items-center cursor-pointer"
                                  >
                                            <img src="@/assets/pdf.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='pdf'" />
                                            <img src="@/assets/doc.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='doc'"/>
                                            <img src="@/assets/docx.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='docx'" />
                                            <img src="@/assets/xls.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='xls'" />
                                            <img src="@/assets/xlsx.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='xlsx'" />
                                            <img src="@/assets/pdf.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='rtf'"/>
                                            <img src="@/assets/txt.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='txt'"/>
                                            <img src="@/assets/png.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='png'"/>
                                            <img src="@/assets/jpg.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='jpg'"/>
                                            <img src="@/assets/jpeg.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='jpeg'"/>
                                            <img src="@/assets/csv.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='csv'"/>
                                            <img src="@/assets/zip.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='zip'"/>
                                            <img src="@/assets/mp4.svg" alt="" v-if=" getFindingEvidenceFileExt(doc)=='mp4'"/>
                                          <div class="flex flex-col w-full min-w-0">
                                            <div class="ml-2 pb-1">
                                              <p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
                                            </div>
                                            <div class="flex justify-between w-full">
                                              <p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
                                              <p class="mr-2 fontSize10PX font-semibold">{{doc.taskId?doc.taskId:'N/A'}}</p>
                                            </div>
                                          </div>
                                  </a>
                              </div>
                          </div>
                          <div v-for="(doc, idx) in findingLinkEvidences" :key="'finding-link-'+idx">
                              <div class="pdf w-full rounded-sm flex flex-row items-center">
                                  <a
                                    href="#"
                                    @click.prevent="openEvidenceFile(doc)"
                                    class="finding-evidence-link-icon cursor-pointer"
                                    :aria-label="doc.url"
                                  >
                                    <span class="finding-evidence-link-icon__img-wrap">
                                      <img src="@/assets/link.svg" alt="Link" class="finding-evidence-link-icon__img" />
                                      <span class="finding-evidence-link-icon__tooltip">{{ doc.url }}</span>
                                    </span>
                                  </a>
                                  <div class="flex flex-col w-full min-w-0">
                                    <div class="ml-2 pb-1">
                                      <p class="text-xs font-medium truncate" :title="doc.filename || doc.name">{{doc.filename || doc.name || 'N/A'}}</p>
                                    </div>
                                    <div class="flex justify-between w-full">
                                      <p class="ml-2 fontSize10PX">{{doc.evidenceDate?formatFileAttachedTime(doc.evidenceDate):'N/A'}}</p>
                                      <p class="mr-2 fontSize10PX font-semibold">{{doc.taskId?doc.taskId:'N/A'}}</p>
                                    </div>
                                  </div>
                              </div>
                          </div>
                          </div>
                          <div v-else-if="presentFindingObject.findingEvidence">{{ presentFindingObject.findingEvidence }}</div>
                          <div v-else>N/A</div>
                      </div>
                      
                    </div>
                    <div class="flex flex-row">
                      <div
                        class="border-l border-b p-2 header w-23 border-lightgrey rounded-bl-md flex items-center"
                      >
                        Finding Severity
                      </div>
                      <div
                        class="border-r border-b border-l border-lightgrey w-77 text-xs p-2 text-justify rounded-br-md flex items-center"
                      >
                        <div
                          v-if="getFindingSeverityValue(presentFindingObject) != null"
                          class="flex items-center justify-center rounded h-5 w-28 px-2.5 regular whitespace-nowrap overflow-hidden"
                          :class="findingSeverityChipBg(presentFindingObject)"
                          :title="getFindingSeverityLabel(presentFindingObject)"
                        >
                          <div class="truncate whitespace-nowrap" :class="findingSeverityChipText(presentFindingObject)">
                            {{ getFindingSeverityLabel(presentFindingObject) }}
                          </div>
                        </div>
                        <span v-else>N/A</span>
                      </div>
                    </div>
                    <!-- <div class="w-full flex flex-row">
                      <div
                        class="border-l w-23 border-b p-2 header border-lightgrey rounded-bl-md"
                      >
                        Finding Category
                      </div>
                      <div
                        class="w-77 border-b border-l border-r border-lightgrey p-2 rounded-br-md"
                      >
                        <div
                          v-if="presentFindingObject.findingCategory === 1"
                          class="flex items-center justify-center rounded w-28 h-5 text-error bg-highColor border-solid border text-sm border-error p-1"
                        >
                          {{
                            getCategory(presentFindingObject.findingCategory)
                          }}
                        </div>
                        <div
                          v-if="presentFindingObject.findingCategory === 2"
                          class="flex items-center justify-center rounded w-28 h-5 text-darkred bg-veryHighColor border-solid border text-sm border-darkred p-1"
                        >
                          {{
                            getCategory(presentFindingObject.findingCategory)
                          }}
                        </div>
                        <div
                          v-if="presentFindingObject.findingCategory === 3"
                          class="flex items-center justify-center rounded w-28 h-5 text-lightgreen bg-veryLowColor border-solid border text-sm border-lightgreen p-1"
                        >
                          {{
                            getCategory(presentFindingObject.findingCategory)
                          }}
                        </div>
                        <div
                          v-if="presentFindingObject.findingCategory === 4"
                          class="flex items-center justify-center rounded w-28 h-5 text-yellow bg-moderateColor border-solid border text-sm border-yellow p-1"
                        >
                          {{
                            getCategory(presentFindingObject.findingCategory)
                          }}
                        </div>
                      </div>
                      <div
                        class="border-l w-23 border-b p-2 header border-lightgrey"
                      >
                        Control Audit Result
                      </div>
                      <div
                        class="border-r w-27 border-b border-l border-lightgrey p-2 rounded-br-md"
                      >
                        <div
                          v-if="presentFindingObject.auditResult === 'Pass'"
                          class="flex items-center justify-center rounded h-5 w-28 text-lightgreen bg-veryLowColor border-solid border border-lightgreen"
                        >
                          {{ presentFindingObject.auditResult }}
                        </div>
                        <div
                          v-if="presentFindingObject.auditResult === 'Fail'"
                          class="flex items-center justify-center rounded h-5 w-28 text-darkred bg-veryHighColor border-solid border border-darkred"
                        >
                          {{ presentFindingObject.auditResult }}
                        </div>
                      </div>
                    </div> -->
                  
                  <!-- <div> -->
                  <div v-if="presentFindingObject.complianceDetails[0]?.clientUniqueId && presentFindingObject.complianceDetails[0]?.clientUniqueId!=null">
                    <div>
                        <div>
                          <div class="border-b border-lightgrey">
                              <p class="mt-4 mb-1.5 header">Control Information</p>
                          </div>
                        </div>
                    <div class="flex">
                      <div class="w-6/12">
                        <p class="font-extrabold mt-2.5 mb-1 text-xs">CID</p>
                        <p class="mt-1 mb-3 text-sm" v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.clientUniqueId!=undefined">{{ presentFindingObject.complianceDetails!=undefined&&presentFindingObject.complianceDetails[0]?.clientUniqueId!='' ? presentFindingObject.complianceDetails[0]?.clientUniqueId : 'N/A'}}</p>
                        <p v-else class="mt-1 mb-2 text-sm">N/A</p>
                      </div>
                      <div class="w-6/12">
                        <p class="font-extrabold mt-2.5 mb-1 text-xs">Frequency</p>
                        <p v-if="presentFindingObject && presentFindingObject !=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails[0]?.controlFrequency!=undefined" class="mt-1 mb-3 text-sm">{{dbFrequency.find((l) => l.value == presentFindingObject.complianceDetails[0]?.controlFrequency)?.key}}</p>
                        <p class="text-sm mt-1 mb-3" v-else>N/A</p>
                      </div>
                      
                    </div>
                    </div>
                    <div class="flex">
                        <div class="w-6/12">
                            <p class="font-extrabold mb-1 text-xs">Title</p>
                            <p class="mt-1 mb-3 text-sm" v-if="presentFindingObject && presentFindingObject !=undefined && presentFindingObject.complianceDetails &&presentFindingObject.complianceDetails.length>0 && presentFindingObject.complianceDetails[0]?.controlTitle!=undefined ">{{presentFindingObject.complianceDetails[0].controlTitle }}</p>
                            <p class="mt-1 mb-3 text-sm" v-else>N/A</p>
                        </div>
                        <div class="w-6/12">
                          <p class="font-extrabold mb-1 text-xs">Type</p>
                          <p class="mt-1 mb-3 text-sm" v-if="presentFindingObject && presentFindingObject !=undefined && presentFindingObject.complianceDetails &&presentFindingObject.complianceDetails.length>0 && presentFindingObject.complianceDetails[0]?.controlType!=undefined ">{{presentFindingObject.complianceDetails[0]?.controlType||'N/A' }}</p>
                          <p class="mt-1 mb-3 text-sm" v-else>N/A</p>
                        </div>
                    </div>
                  
                    <div class="flex">
                      <div class="w-6/12">
                        <p class="font-extrabold mb-1 text-xs">Class</p>
                        <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.controlClass!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.complianceDetails[0].controlClass||'N/A' }}</p>
                        <p v-else class="text-sm mt-1 mb-3">N/A</p>
                      </div>
                      <div class="w-6/12">
                        <p class="font-extrabold mb-1 text-xs">Family</p>
                        <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.controlFamily!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.complianceDetails[0].controlFamily||'N/A' }}</p>
                        <p v-else class="text-sm mt-1 mb-3">N/A</p>
                      </div>

                    </div>
                    <div class="flex flex-row"> 
                      <div class="w-6/12">
                        <label class="font-extrabold text-xs">Priority</label>
                        <div v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.controlPriority!=undefined && typeof presentFindingObject.complianceDetails[0]?.controlPriority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(presentFindingObject.complianceDetails[0]?.controlPriority)">
                          <div class="text-xs" :class="colorLabelText(presentFindingObject.complianceDetails[0]?.controlPriority)">
                          {{ getProirityLabel(presentFindingObject.complianceDetails[0]?.controlPriority) }}
                          </div>
                        </div>
                        <div v-else class="text-sm mt-1 mb-3">N/A</div>
                      </div>
                    </div>
                    <div> 
                      <label class="font-extrabold mt-2 text-xs">Description</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.Description!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.complianceDetails[0]?.Description||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                    <div> 
                      <label class="font-extrabold mt-2 text-xs">Policy/Procedure</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.controlPolicies!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.complianceDetails[0].controlPolicies||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                    <div>
                      <label class="font-extrabold mt-2 mb-1 text-xs">Guidance</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.controlGuidance!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.complianceDetails[0].controlGuidance||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                    <div> 
                      <label class="font-extrabold mt-2 mb-1  text-xs">Task</label>
                      <p v-if="presentFindingObject && presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0&& presentFindingObject.complianceDetails[0]?.controlMaintenanceTask!=undefined" class="mt-1 mb-3 text-sm">{{ presentFindingObject.complianceDetails[0].controlMaintenanceTask||'N/A' }}</p>
                      <p v-else class="text-sm mt-1 mb-3">N/A</p>
                    </div>
                    </div>
                    <div v-else-if="presentFindingObject?.riskInformation && presentFindingObject?.riskInformation.length>0">
                    <div>
                        <div>
                          <div class="border-b border-lightgrey">
                              <p class="mt-4 mb-1.5 header">Risk Information</p>
                          </div>
                        </div>
                        <div class="flex mb-1">
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">Risk</p>
														<p v-if="(presentFindingObject?.riskInformation[0]?.risk||'N/A')" class="mt-1 text-sm">{{ presentFindingObject?.riskInformation[0]?.risk ||'N/A'}}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mt-3 mb-1 text-xs">Priority</p>
														<div v-if="presentFindingObject?.riskInformation[0]?.priority && typeof presentFindingObject?.riskInformation[0]?.priority === 'number'"	class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="colorLabelBg(presentFindingObject?.riskInformation[0]?.priority)">
															<div class="text-xs" :class="colorLabelText(presentFindingObject?.riskInformation[0]?.priority)">
															{{ getProirityLabel(presentFindingObject?.riskInformation[0]?.priority) }}
															</div>
														</div>
														<div v-else class="text-sm mt-2">N/A</div>

													</div>
													
												</div>

												<div class="flex mb-1">
													<!-- <div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Action</p>
														<p v-if="(riskInformationArray.riskInformation.action)" class="mt-1 text-sm">{{riskInformationArray.riskInformation.action||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div> -->
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Risk Category</p>
														<p v-if="(presentFindingObject?.riskInformation[0]?.riskCategory)" class="mt-1 text-sm">{{ presentFindingObject?.riskInformation[0]?.riskCategory||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													<div class="w-6/12">
														<p class="font-extrabold mb-1 text-xs">Risk Owner</p>
														<p v-if="(presentFindingObject?.riskInformation[0]?.riskOwner)" class="mt-1 text-sm">{{ getRiskOwnerLabel(presentFindingObject?.riskInformation[0]?.riskOwner)||'N/A' }}</p>
														<p v-else class="text-sm mt-1">N/A</p>
													</div>
													
												</div>
												<div class="flex mb-1">
													<div class="w-6/12">
														<p class="font-extrabold mt-2 mb-1 text-xs">Threat Category</p>
														<p v-if="(presentFindingObject?.riskInformation[0]?.threatCategory)" class="mt-1 mb-3 text-sm">{{ presentFindingObject?.riskInformation[0]?.threatCategory||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
                          <div class="w-6/12"> 
                            <label class="font-extrabold mt-2 mb-1 text-xs">Threat Source</label>
                            <p v-if="(presentFindingObject?.riskInformation[0]?.threatSource)" class="mt-1 mb-3 text-sm">{{ presentFindingObject?.riskInformation[0]?.threatSource||'N/A' }}</p>
                            <p v-else class="text-sm mt-1 mb-3">N/A</p>
                          </div>
													

												</div>
												<div class="w-full">
														<p class="font-extrabold mt-2 mb-1 text-xs">Threat</p>
														<p v-if="(presentFindingObject?.riskInformation[0]?.threatEvent)" class="mt-1 mb-3 text-sm">{{ presentFindingObject?.riskInformation[0]?.threatEvent||'N/A' }}</p>
														<p v-else class="text-sm mt-1 mb-3">N/A</p>
													</div>
												<div class="w-full"> 
													<label class="font-extrabold mt-2 text-xs">Vulnerability</label>
													<p v-if="(presentFindingObject?.riskInformation[0]?.vulnerability)" class="mt-1 mb-3 text-sm">{{ presentFindingObject?.riskInformation[0]?.vulnerability||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
                        <div class="w-full">
													<p class="font-extrabold mb-2 text-xs">Risk Assessment</p>
													<p v-if="(presentFindingObject?.riskInformation[0]?.riskAssessment!='')" class="mt-1 mb-3 text-sm">{{ presentFindingObject?.riskInformation[0]?.riskAssessment||'N/A' }}</p>
													<p v-else class="text-sm mt-1 mb-3">N/A</p>
												</div>
												<div class="w-full">
													<p class="font-extrabold mb-1 text-xs">Treatment Summary</p>
													<p v-if="(presentFindingObject?.riskInformation[0]?.action!='')" class="mt-1 text-sm">{{ treatmentSummaryData(presentFindingObject?.riskInformation[0]?.action)||'N/A' }}</p>
													<p v-else class="text-sm mt-1">N/A</p>
												</div>
												</div>
												<div>
												<h1 class="upperspacing">Inherited Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.business)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.business)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.business,1)||'N/A'}}
																</div>
															</div>
															
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															 <div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.financial)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.financial)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.operations)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.operations)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.legal)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.legal)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.likelihood)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.likelihood)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
															<label class="controllabel">Overall Impact</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.overallImpact)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.overallImpact)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.overallImpact,6)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												</div>
												<div v-if="presentFindingObject?.riskInformation[0]?.action && presentFindingObject?.riskInformation[0]?.action!=10419">
													<h1 class="upperspacing">Residual Risk</h1>
												<!-- </div> -->
												<div class="border-b pt-1 border-solid border-lightgrey"></div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Strategic</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.residual?.[0]?.business)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.residual?.[0]?.business)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.residual?.[0]?.business,1)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Financial</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.residual?.[0]?.financial)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.residual?.[0]?.financial)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.residual?.[0]?.financial,2)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>

												<div class="formcontainer flex flex-col upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-6/12">
															<label class="controllabel">Operations</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.residual?.[0]?.operations)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.residual?.[0]?.operations)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.residual?.[0]?.operations,3)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-6/12 leftspacing">
															<label class="controllabel">Compliance</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.residual?.[0]?.legal)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.residual?.[0]?.legal)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.residual?.[0]?.legal,4)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												<div class="formcontainer upperspacing">
													<div class="row flex flex-row w-full">
														<div class="w-3/6">
															<label class="controllabel">Likelihood</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.residual?.[0]?.likelihood)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.residual?.[0]?.likelihood)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.residual?.[0]?.likelihood,5)||'N/A'}}
																</div>
															</div>
														</div>

														<div class="w-3/6 leftspacing">
															<label class="controllabel">Overall Impact</label>
															<div class="flex items-center justify-center rounded h-5 w-24 mt-1" :class="bgColor(presentFindingObject?.riskInformation[0]?.overallImpact)">
																<div :class="colorLabel(presentFindingObject?.riskInformation[0]?.overallImpact)">
																	{{getLablesInfo(presentFindingObject?.riskInformation[0]?.overallImpact,6)||'N/A'}}
																</div>
															</div>
														</div>
													</div>
												</div>
												</div>
                    </div>
                    </div>
                  <!-- </div> -->
                  <!-- </div> -->
                </div>
                <div class="overflow-y-auto descriptionToggle" v-if="tab.id == 2">
                  <div>
                    <div
                      class="border-b border-lightgrey flex justify-between pb-2 mb-5"
                    >
                      <div class="flex items-center justify-center">
                        <div>
                          <p class="header">Causes & Actions</p>
                        </div>
                      </div>
                      <div>
                        <div
                          class="buttonposition flex justify-center items-center"
                        >
                          <div
                            class="buttonposition flex justify-center items-center"
                          >
                          <button :class="TaskDetailsDropDown.findingStatus == 10418 || approvalObj.statusCode == 10403 || !isAddDisabled(10302) ? 'btndisabled  pointer-events-none' : 'filterButton' " @click="openCausePopup()">
                              Add Cause
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- <div v-for="(obj, index) in presentFindingObject" :key="index"> -->
                 
                                        <div v-if="presentFindingObject.causes != undefined  && presentFindingObject.tasks == undefined">
                                            <div v-for="(cause, number) in presentFindingObject.causes" class="mb-3" :key="number" >
                                                <div class="border border-lightgrey bg-moderategrey">
                                                    <div class="w-full flex flex-row">
                                                        <div class="w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center">Cause for this Finding </div>
                                                                <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify">{{ presentFindingObject.causes[number].cause}}</div>
                                                        <div class="w-15 flex items-center justify-center">
                                                            <div class="flex justify-around w-full">
                                                                <img src="@/assets/editdefault.svg" class="cursor-pointer"  @click="editCauseAndAction(cause)" />
                                                                <img src="@/assets/deleteIcon.svg" class="cursor-pointer" @click="deleteCauseAndAction(cause.causeId, cause.cause)" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <ul>
                                                    <li v-for="(action, index) in cause.actions" :key="index">
                                                        <div class="border border-lightgrey">
                                                            <div class="w-full flex flex-row">
                                                                <div class="w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center">Action{{ index + 1 }} for this Finding </div>
                                                                        <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify">{{ action.action }}</div>
                                                                <div class="w-15 p-3 flex flex-row items-center justify-center">
                                                                    <!-- <img src="@/assets/link.svg" class="mr-3 cursor-pointer"/> -->
                                                                    <!-- <img src="@/assets/deleteIcon.svg" class="cursor-pointer"/> -->
                                                                     <div class="flex items-center justify-center rounded h-5 w-full bg-lightgrey border-solid border border-disabledgrey">
                                                                        <div class="font-semibold text-xs text-disabledgrey">
                                                                            Not Started
                                                                        </div>
                                                                     </div>
                                                                </div>
                                                            </div>
                                                    </div>
                                                       
                                                        </li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div v-else-if="presentFindingObject.tasks != undefined">
                                            <div v-for="(task, number) in finalFindingsTasks" class="mb-3" :key="number" >
                                                <div class="border border-lightgrey bg-moderategrey">
                                                    <div class="w-full flex flex-row">
                                                        <div class="w-15 p-3 border-l-4 border-darkred header text-base flex items-center justify-center">Cause for this Finding </div>
                                                                <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify">{{ number }}</div>
                                                        <div class="w-15 flex items-center justify-center p-3">
                                                          <div class="flex items-center justify-center rounded h-5 w-full evidenceUpload border-solid border border-primary">
                                                            <div class="font-semibold text-xs text-primary">
                                                                Approved
                                                            </div>
                                                          </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-for="(task1, num) in task" :key="num">
                                                <ul>
                                                    <li>
                                                        <div class="border-b border-x border-lightgrey">
                                                            <div class="w-full flex flex-row">
                                                                <div class="w-15 p-3 border-l-4 border-lightgreen header text-base flex items-center justify-center">Action{{ num + 1 }} for this Finding</div>
                                                                        <div class="w-70 p-3 border-x border-lightgrey text-xs text-justify cursor-pointer" @click="goToActionTasks(task1._id)">{{ task1.action }}</div>
                                                                <div class="w-15 p-3 flex flex-row items-center justify-center">
                                                                    <div class="flex items-center justify-center rounded h-5 w-full" :class="colorFindingBg(task1.statusCode)">
                                                                            <div class="text-xs" :class="colorFindingText(task1.statusCode)">
                                                                                {{ getStatusLabel(task1.statusCode) }}
                                                                            </div>
                                                                        </div>
                                                                </div>
                                                            </div>
                                                         </div>  
                                                    </li>
                                                </ul>
                                                </div>
                                               
                                               
 
                                            </div>
                                        </div>
 
                  <!-- </div> -->
                </div>
                <div
                  class="overflow-y-auto descriptionToggle" v-if="tab.id == 3">
                  <div>
                    <div
                      class="border-b border-lightgrey flex justify-between pb-2 mb-5"
                    >
                      <div class="flex items-center justify-center">
                        <div>
                          <p class="header">Comments</p>
                        </div>
                      </div>
                      <div>
                        <div
                          class="buttonposition flex justify-center items-center"
                        >
                          <div
                            class="buttonposition flex justify-center items-center"
                          >
                            <button
                              class="filterButton flex"
                              v-if="oldComments"
                              @click="sortComments()"
                              :class="Object.keys(this.presentFindingObject).includes('comments') && this.presentFindingObject.comments.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none'"
                            >
                              <img
                                src="@/assets/sortBy.svg"
                                class="h-3 mr-2.5"
                              />
                              Oldest
                            </button>
                            <button
                              class="filterButton flex"
                              v-if="!oldComments"
                              @click="sortComments()"
                            >
                              <img
                                src="@/assets/sortBy.svg"
                                class="h-3 mr-2.5 rotate-180"
                              />
                              Newest
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <!-- <div class="comment-box w-full">
                        <div class="my-3">
                          <textarea
                            placeholder="Add a Comment"
                            class="w-full text-xs border border-lightgrey rounded-sm p-2"
                            rows="4"
                            v-model="comment"
                            :disabled="approvalObj.statusCode == 10403"
                            @input="handleInput"
                          ></textarea>
                        </div>
                        <div class="flex justify-end">
                          <button
                            @click="addComment"
                            class="mr-2"
                            :class="{
                              btnprimary: !btnDisabled,
                              btndisabled: btnDisabled,
                            }"
                            :disabled="btnDisabled"
                          >
                            Add
                          </button>
                          <button
                            @click="clearComment"
                            :class="{
                              btnprimary: !btnDisabled,
                              btndisabled: btnDisabled,
                            }"
                            :disabled="btnDisabled"
                          >
                            Cancel
                          </button>
                        </div>
                      </div> -->
                      <commentsEditor v-if="TaskDetailsDropDown.findingStatus!=10403 && TaskDetailsDropDown.findingStatus!=10418 && isAddDisabled(10302)" :taskStatusCode="TaskDetailsDropDown.findingStatus"/>
                      <!-- dfghjkl {{ presentFindingObject[0].comments }} -->
                      <div class="comments">
                        <!-- <div v-for="(obj, index) in presentFindingObject" :key="index"> -->
                        <div
                          v-for="(
                            obj, number
                          ) in presentFindingObject.comments"
                          :key="number"
                          class="border border-lightgrey mt-2 rounded-sm flex flex-row p-3"
                        >
                        <div v-if="Object.keys(obj).includes('createdBy')" class="initials">
                          {{ extractInitials(getPersonName(obj.createdBy)) }}
                        </div>
                        <div v-if="Object.keys(obj).includes('updatedBy')" class="initials">
                          {{ extractInitials(getPersonName(obj.updatedBy)) }}
                        </div>
                        
                          <div class="w-1/5">
                            <div class="header">
                              {{
                                getPersonName(obj.createdBy)
                              }}
                            </div>
                            <div class="fontSize10PX">
                              {{ obj.createdAt }}
                            </div>
                          </div>
                          <div class="w-4/5 text-xs text-justify" >
                             <safeHtml :content="obj.comment"/>
                          </div>
                        </div>
                        <!-- </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="overflow-y-auto descriptionToggle" v-if="tab.id == 5">
                  <div>
                                        <div class="border-b border-lightgrey flex justify-between pb-2">
                      <div class="flex items-center justify-center">
                        <div>
                          <p class="header">WorkLog</p>
                        </div>
                      </div>
                      <div>
                         <div class="buttonposition flex justify-center items-center">
                            <div class="buttonposition flex justify-center items-center">
                                <button class="filterButton flex" v-if="oldHistory" @click="sortHistory()" :class="Object.keys(this.workLogObject).includes('findingHistory') && this.workLogObject.findingHistory.length != 0 ? 'filterButton' : 'btndisabled pointer-events-none'">
                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5" />
                                  Oldest
                                </button>
                                <button class="filterButton flex" v-if="!oldHistory" @click="sortHistory()">
                                    <img src="@/assets/sortBy.svg" class="h-3 mr-2.5 rotate-180" />
                                Newest
                              </button>
                          </div>
                        </div>
                      </div>
                    </div>
                      <div v-for="work in workLogObject.findingHistory" :key="work" class="bg-white py-4 mb-0.5 border-lightgrey border-b w-full">
                                                  <!-- {{ work.additionalInfo }} -->
                      <div class="flex">
                        <div v-if="Object.keys(work).includes('createdBy')" class="initials">
                          {{ extractInitials(work.name) }}
                        </div>
                        <div v-if="Object.keys(work).includes('updatedBy')" class="initials">
                          {{ extractInitials(work.name) }}
                        </div>
                        <div class="logContainer w-93">
                          <div class="flex mt-1">
                           <p v-if="Object.keys(work).includes('createdBy')" class="font-semibold text-xs">
                              {{work.name }}
                            </p>
                            <p v-else-if="Object.keys(work).includes('updatedBy')" class="font-semibold text-xs">
                              {{ work.name }}
                            </p>

                            <p v-if="work.actionEntity == 10301" class="mx-2 text-xs">{{ 'Created the Finding on' }}</p>
                            <p v-else-if="work.statusCode != undefined && work.statusCode == 10418" class="mx-2 text-xs">{{ 'Terminated the Finding on' }}</p>
                            <p v-else-if="work.actionEntity == 10302" class="mx-2 text-xs">{{ 'Updated the Finding on' }}</p>

                            <p v-if="Object.keys(work).includes('createdAt')" class="font-semibold  text-xs">{{ formatTime(work.createdAt) }}</p>
                            <p v-if="Object.keys(work).includes('updatedAt')" class="font-semibold text-xs">{{ formatTime(work.updatedAt) }}</p>
                          </div>

                       <div class="mt-3" v-if="Object.keys(work).includes('additionalInfo')">
                            <div v-if="work.additionalInfo.comment" class="flex">
                                  <div class="font-semibold text-xs pr-2">Comment:</div>
                                  <div class="text-xs text-justify">
                                      <safeHtml :content="work.additionalInfo.comment"/>
                                  </div>
                            </div>
                            <div v-if="work.additionalInfo.cause" class="flex flex-row">
                                <div v-if="work.additionalInfo.action == 10301" class="font-semibold text-xs w-18">Created the Cause :</div>
                                <div v-else-if="work.additionalInfo.action == 10302" class="font-semibold text-xs w-18">Updated the Cause :</div>
                                <div v-else-if="work.additionalInfo.action == 10303" class="font-semibold text-xs w-18">Deleted the Cause :</div>
                                <div class="text-xs w-82 text-justify ml-2">{{ work.additionalInfo.cause}}</div>
                            </div>
                            <div class="flex" v-if="Object.keys(work.additionalInfo).includes('assignee')">
                                <p class="font-semibold text-xs">{{'Assigned the Task To -'}}</p>
                                <p class="mx-2 text-xs text-justify">{{ work.additionalInfo.name }}</p>
                            </div>
                                                                
                            <div class="flex" v-if="Object.keys(work.additionalInfo).includes('approver')">
                                <p class="font-semibold text-xs">{{'Sent Approval for -'}}</p>
                                <p class="mx-2 text-xs text-justify">{{ getPersonName(work.additionalInfo.approver) }}</p>
                            </div>
                            <div class="flex" v-if="work.additionalInfo.approvalStatusCode == 10410">
                                <p class="font-semibold text-xs text-justify">{{'Approval is Rejected :'}}</p>
                                <p class="font-normal text-xs text-justify ml-2">{{work.additionalInfo.justification}}</p>
                            </div>
                            <div class="flex" v-if="work.additionalInfo.approvalStatusCode == 10403">
                                <p class="font-semibold text-xs text-justify">{{'Approval is Accepted'}}</p>
                            </div>
                            <div v-if="Object.keys(work.additionalInfo).includes('previousStatus')">
                              <div class="flex items-center">
                                <div>
                                    <p class="font-semibold text-xs text-justify">{{'Updated The Status :'}}</p>
                                </div>
                                <div class="flex ml-4">
                                  <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.previousStatus)">
                                      <div class="text-xs" :class="colorFindingText(work.additionalInfo.previousStatus)">
                                          {{ getStatusLabel(work.additionalInfo.previousStatus) }}
                                    </div>
                                  </div>
                                  <div class="mx-4 flex items-center"><img src="@/assets/arrowRight.svg"/></div>
                                  <div class="flex items-center justify-center rounded h-5 labelWidth" :class="colorFindingBg(work.additionalInfo.updatedStatus)">
                                      <div class="text-xs" :class="colorFindingText(work.additionalInfo.updatedStatus)">
                                          {{ getStatusLabel(work.additionalInfo.updatedStatus) }}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              <div
                                v-if="(work.additionalInfo.previousStatus == 10406 || work.additionalInfo.previousStatus == 10402) && (work.additionalInfo.updatedStatus == 10406 || work.additionalInfo.updatedStatus==10403) && work.additionalInfo.taskId"
                                class="mt-1 text-xs"
                              >
                                ID:<span class="font-semibold ml-1">{{ work.additionalInfo.taskId }}</span> is completed
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="overflow-y-auto descriptionToggle" v-if="tab.id == 4">
                  <div>
                    <div
                      class="border-b border-lightgrey flex justify-between pb-2"
                    >
                    <!-- {{newAssignee}} -->
                      <div class="flex items-center justify-center">
                        <div>
                          <p class="header">Approvals</p>
                        </div>
                      </div>
                      <div>
                        <div
                          class="buttonposition flex justify-center items-center"
                        >
                          <div
                            class="buttonposition flex justify-center items-center"
                          >
                          <button class="flex" :class="causesLength == true || approvalObj.statusCode == 10401 || approvalObj.statusCode == 10403  || !isAddDisabled(10302)? 'btndisabled  pointer-events-none' : 'filterButton'"  @click="openApprovalpopup()">
                              Send Approval
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div v-for="(approval, number) in presentFindingObject.approvals" :key="number" class="bg-white flex flex-row p-4 mb-0.5 border-lightgrey border-b w-full">
                            <div v-if="approval.createdBy != undefined" class="initials">{{extractInitials(getPersonName(approval.createdBy))}}</div>
                            <div v-if="approval.createdBy != undefined" class="font-semibold mt-1 text-xs">{{ getPersonName(approval.createdBy) }}</div>
                            
                            <div v-if="approval.updatedBy != undefined" class="initials">{{extractInitials(getPersonName(approval.updatedBy))}}</div>
                            <div v-if="approval.updatedBy != undefined" class="font-semibold mt-1 text-xs">{{ getPersonName(approval.updatedBy) }}</div>

                            <div v-if="approval.statusCode == 10401" class="mx-2 mt-1 text-xs"> {{' Requested an approval '}} </div>
                            <div v-else-if="approval.statusCode == 10410" class="mx-2 mt-1 text-xs"> {{' Rejected an approval '}} </div>
                            <div v-else-if="approval.statusCode == 10403" class="mx-2 mt-1 text-xs"> {{' Approved an approval '}} </div>

                            <div v-if="approval.createdAt != undefined" class="font-semibold mt-1 text-xs">{{approval.createdAt}}</div>
                            <div v-if="approval.updatedAt != undefined" class="font-semibold mt-1 text-xs">{{approval.updatedAt}}</div>
                        </div>
                        </div>
                        </div>
                </div>
                

                  </div>
                  </TabPanel>
                </TabPanels>
            </Tabs>
             <div
              class="w-20 border taskDetailsRightBar rounded-sm border-lightgrey"
            >
              <div class="m-3">
                <div class="pb-2 border-b border-lightgrey">
                  <h1>Finding Details</h1>
                </div>
                <div v-if="tabDataLoading == true">
                  <div class="flex items-center justify-center w-full h-16 skeleton">
								    <dots-loader/>
                  </div>
                </div>
                <div v-else class="pt-1.5 overflow-y-scroll thirtyWidthToggle">
                  <div class="flex flex-col">
                    <label class="controllabel">Finding Status</label>
                   <!-- <select
                      class="mt-2 mb-3 custom-select cursor-pointer w-full no-interaction px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
                      :class="changeBackground()"
                      v-model="TaskDetailsDropDown.findingStatus"
                      @change="
                        updateFindingStatus(TaskDetailsDropDown.findingStatus)
                      "
                    >
                      <option value="" selected disabled hidden>
                        Please select one
                      </option>
                      <option
                        v-for="i in findingStatusData"
                        :value="i.id"
                        :key="i"
                      >
                        {{ i.status }}
                      </option>
                    </select> -->
                    <Select
                      v-model="TaskDetailsDropDown.findingStatus"
                      :options="statuses"
                      @change="updateTaskStatus(TaskDetailsDropDown.taskStatus)"
                      optionLabel="label"
                      optionValue="id"
                      class="w-full no-interaction custom-select mt-2 border border-lightgrey"
                      :class="changeBackground()"
                  />
                    <!-- <select
                      class="custom-select cursor-pointer w-full px-2.5 py-1 text-sm font-light text-gray rounded-sm border-solid border border-lightgrey"
                      v-else
                     :disabled="TaskDetailsDropDown.taskStatus == 10403 || presentFindingObject.statusCode == 10403|| presentFindingObject.statusCode == 10418 || presentFindingObject.tasks != undefined"
                      
                      v-model="TaskDetailsDropDown.taskStatus"
                    >
                      <option value="" selected disabled hidden>
                        Please select one
                      </option>
                      <option
                        v-for="i in terminateArray"
                        :value="i.id"
                        :key="i"
                      >
                        {{ i.status }}
                      </option>
                    </select> -->
                  </div>

                  <div>
                    <div class="mt-3">
                      <label class="controllabel">Assignee</label>
                      <div v-if="TaskDetailsDropDown.taskStatus == 10403 || presentFindingObject.statusCode == 10403 || presentFindingObject.statusCode == 10418 || (presentFindingObject.teamOwner != userInfo._id && ( newAssignee.value != userInfo._id))">
                         <p class="mt-2"> {{ newAssignee.label}}</p>
                      </div>
                      <div v-else>
                            <!-- <multiselect
                                v-model="presentFindingObject.assignee"
                                :options="userOptions"
                                :showNoOptions="false"
                                @search-change="asyncFind"
                                :multiple="false"
                                :close-on-select="true"
                                :clear-on-select="true"
                                label="label"
                                open-direction="bottom"
                                track-by="value"
                                @select="updateAssignedMember(presentFindingObject.assignee)"
                                :searchable="true"
                                :hideArrow="false"
                                placeholder="Assigned-To"
                                deselectLabel=""
                                selectLabel=""
                                class="custom-multiselect mt-2"
                              >F
                            <template v-slot:noResult>
                              <span class="text-xs">No Members Found</span>
                            </template>
                            </multiselect> -->
                            <AutoComplete 
                              v-model="presentFindingObject.assignee"
                              :suggestions="userOptions"
                              @complete="asyncFind"
                              :disabled="!isAddDisabled(10302)"
                              @item-select="updateAssignedMember(presentFindingObject.assignee)"
                              optionLabel="label"
                              optionValue="value"
                              :forceSelection="true"
                              placeholder="Assigned-To"
                              class="p-inputtext-sm systemsstyling  mt-2 custom-multiselect userSelect"
                              />
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <label class="controllabel">Reviewer</label><br />
                    <div class="mt-2 text-sm" v-if="presentFindingObject.reviewer != undefined || presentFindingObject.reviewer != null">
                      {{ getPerson(presentFindingObject.reviewer) }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                    <div class="mb-3 mt-4" v-if='((presentFindingObject.appId && presentFindingObject.appId==10003)|| presentFindingObject.treatmentType!=undefined)'>
                      <label class="controllabel mb-2">Treatment Type</label><br>
            
                      <div class="flex items-center justify-center rounded h-5 w-24 mt-2 mb-3" :class="treatmentTypeBgColor(presentFindingObject.treatmentType)">
                        <div class="text-xs" :class="treatmentTypeTextColor(presentFindingObject.treatmentType)">
                        {{ presentTask(presentFindingObject.treatmentType)||'N/A' }}
                        </div>
                      </div>
                      
                    </div>
                  <div class="mt-3">
                    <label class="controllabel">Team Representative</label><br />
                    <div class="mt-2 text-sm" v-if="presentFindingObject.teamOwner != undefined || presentFindingObject.teamOwner != null">
                      {{ getAllPersonName(presentFindingObject.teamOwner) }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                  <div class="mt-3">
                    <label class="controllabel">Team</label><br />
                    <div class="mt-2 text-sm" v-if="presentFindingObject.department != undefined || presentFindingObject.department != null">
                      {{ getTeamName(presentFindingObject.department) }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                  <div class="mt-3">
                      <label class="controllabel">Location</label><br />
                      <!-- {{ presentFindingObject }} -->
                      <!-- <div class="mt-2 mb-3 text-sm" v-if="presentFindingObject.entity != undefined || presentFindingObject.entity != null">
                        {{ getLocationName(presentFindingObject.entity,presentFindingObject.entitytypecodeid) }}
                      </div>
                      <div v-else-if="presentFindingObject.entity == 'global'">{{presentFindingObject.entity}}</div>
                      <p class="mt-2 text-sm" v-else>N/A</p> -->
                      <!-- <div v-if="presentFindingObject.department != undefined || presentFindingObject.department != null" class="mt-2 text-sm">{{ getDeptEntity(presentFindingObject.department) }}</div>
                      <p class="mt-2 text-sm" v-else>N/A</p> -->
                      <!-- {{ presentFindingObject }} -->
                      <div v-if="Object.keys(presentFindingObject).includes('location') && presentFindingObject.location!=undefined" class="mt-2">{{ presentFindingObject.location }}</div>
                      <div v-else-if="Object.keys(presentFindingObject).includes('location') && !Object.keys(presentFindingObject).includes('entity') && presentFindingObject.location != '' && presentFindingObject.location != null" class="mt-2 text-sm">{{ getEntity(presentFindingObject.location) }}</div>
                      <div v-else-if="Object.keys(presentFindingObject).includes('entity') && presentFindingObject.entity != '' && presentFindingObject.entity != null && presentFindingObject.entity != undefined" class="mt-2">{{ getEntity(presentFindingObject.entity) }}</div>
                      <div v-else-if="Object.keys(presentFindingObject).includes('location') && presentFindingObject.location==null && presentFindingObject.department!=''">{{getLocationNameForSystem(presentFindingObject.department)}}</div>
                      <div v-else-if='presentFindingObject.location==null' class="mt-2 text-sm"  >
                          <div v-for="val in locationObject" :key='val._id'>
                            <div v-if="val.entityType==1">{{val?.label|| 'N/A'}}</div>
                          </div>
                          <!-- {{ getLocation(presentFindingObject?.department) }} -->
                      </div>
                      <p class="mt-2 text-sm" v-else>N/A</p>
                    </div>
                  <!-- <div class="mt-3">
                    <label class="controllabel">Compliance ID</label><br />
                    <div class="mt-2 text-sm" v-if="presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0 && presentFindingObject.complianceDetails[0]?.complianceId && presentFindingObject.complianceDetails[0]?.complianceId!=undefined">
                      {{ presentFindingObject.complianceDetails[0].complianceId?.toUpperCase()}}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                   <div class="mt-3">
                    <label class="controllabel">Compliance Title</label><br />
                    <div class="mt-2 text-sm" v-if="presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0 && presentFindingObject.complianceDetails[0]?.complianceTitle && presentFindingObject.complianceDetails[0]?.complianceTitle!=undefined">
                      {{ presentFindingObject.complianceDetails[0].complianceTitle }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div>
                   <div class="mt-3">
                    <label class="controllabel">Compliance Period</label><br />
                    <div class="mt-2 text-sm" v-if="presentFindingObject!=undefined && presentFindingObject.complianceDetails && presentFindingObject.complianceDetails.length>0 && presentFindingObject.complianceDetails[0]?.compliancePeriod">
                      {{ presentFindingObject.complianceDetails[0].compliancePeriod }}
                    </div>
                    <p class="mt-2 text-sm" v-else>N/A</p>
                  </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popup v-if="showCausePopup" :popUp="showCausePopup">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>Cause and Action</h1>
          <button
            class="float-right text-3xl"
            @click="onCrossbtnForCauseAndAction()"
          >
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
  <div class='flex flex-col h-full'>
    <div class="flex-1 overflow-auto">
      <div class="formcontainer px-4 pb-4 flex flex-col">
        <div class="row flex flex-row upperspacing">
          <div class="w-full">
            <label class="controllabel">Cause</label>
            <input
              class="inputboxstyling mt-2"
              type="text"
              v-model.trim="causeActionObj.cause"
              placeholder="Cause for the Finding"
              @input="v$.causeActionObj.cause.$touch()" 
              :class="{ 'is-invalid': v$.causeActionObj.cause.$error }"
            />
            <div v-if="v$.causeActionObj.cause.$error" class="text-red-500">
              <div class="error-text" v-if="v$.causeActionObj.cause.required.$invalid">Required</div>
              <div v-else-if="v$.causeActionObj.cause.required && v$.causeActionObj.cause.restrictCharacters100.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
            </div>
          </div>
        </div>
        <div class="flex justify-end items-center mt-2">
          <button class="btnprimary" @click="addTextarea()">Add</button>
        </div>
        <label class="controllabel">Actions</label>
        <div v-if="textareas.length == 0" class="text-red-500">
          <div class="error-text">Enter atleast one Action</div>
        </div>
        <div>
        <div
          v-for="(textarea, index) in textareas"
          :key="index"
          class="mb-2"
        >
         <!-- <label class="controllabel">
            Action {{ index + 1 }}
          </label> -->
          <div class="w-full flex flex-row">
            <div class="w-95 mr-5">
              <textarea
                class="inputboxstyling mt-2"
                v-model.trim="textarea.action"
                placeholder="Add an action for this Cause"
                rows="3"
                :class="{
                  'is-invalid borderRed':
                    v$.textareas.$dirty &&
                    !v$.textareas.$each.$response.$data[index].action.required,
                }"
              ></textarea>

              <div
                v-if="
                  v$.textareas.$dirty &&
                  !v$.textareas.$each.$response.$data[index].action.required
                "
                class="text-red-500"
              >
                <div class="error-text">Required</div>
              </div>
            </div>
            <div class="w-5">
              <div class="flex items-center justify-center h-full">
                <img
                  src="@/assets/deleteIcon.svg"
                  class="cursor-pointer"
                  @click="clickedOnDeleteButton(index)"
                />
              </div>
            </div>
          </div>
          <div class="w-1/2 mt-3">
            <label class="controllabel">Target Date</label>
            <input
              v-model="textarea.targetDate"
              type="date"
              class="mt-2 w-1/2"
              @focus="openCalendar"
              style="height:28px"
              onkeydown="return false"
              :max="todayDate"
              :class="{
                'inputboxstylingForSelectAtPopup': textarea.targetDate == '',
                'stylingForInputboxstylingForSelectAtPopup': textarea.targetDate != '',
                'is-invalid borderRed':
                  v$.textareas.$dirty &&
                  v$.textareas.$each.$response.$data[index] &&
                  v$.textareas.$each.$response.$data[index].targetDate &&
                  !v$.textareas.$each.$response.$data[index].targetDate.required,
              }"
            />
            <div
              v-if="
                v$.textareas.$dirty &&
                v$.textareas.$each.$response.$data[index] &&
                v$.textareas.$each.$response.$data[index].targetDate &&
                !v$.textareas.$each.$response.$data[index].targetDate.required
              "
              class="text-red-500"
            >
              <div class="error-text">Target Date is Required</div>
            </div>
          </div>
           <!-- <hr
                v-if="index < textareas.length - 1"
                class="my-4 border-gray-300"
              /> -->
        </div>
      </div>
        <!-- {{ objDummy }}dummy{{  causeActionObj }} -->
        <!-- causeActionObj {{ causeActionObj }} textareas
        {{ textareas }} textareaEditDummy {{ textareaEditDummy }} -->
        <!-- {{ (JSON.stringify(causeActionObj.actions) != JSON.stringify(objDummy.actions)) }} -->
        
      </div>
    </div>
    <div>
      <div class="border-b border-solid border-lightgrey mx-5"></div>
      <div v-if="!editVariable" class="flex items-center justify-end pb-4 pl-5 pt-4 pr-5">
          <button
            class="btnprimary mr-2"
            :class="
              JSON.stringify(causeActionObj.cause) !=
                JSON.stringify(causeActionObjDummy.cause) ||
              JSON.stringify(textareas) != JSON.stringify(textareasDummy)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            "
            @click="cancelCauseAction()"
          >
            Reset
          </button>
          <button
            class="btnprimary"
            :disabled="clickOnButtonForCause"
            :class="
              JSON.stringify(causeActionObj.cause) !=
                JSON.stringify(causeActionObjDummy.cause) &&
              JSON.stringify(textareas) != JSON.stringify(textareasDummy)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            "
            @click="saveCauseAction()"
          >
            Save
          </button>
        </div>
        <div v-if="editVariable" class="flex items-center justify-end pb-4 pl-5 pt-4 pr-5">
          <button
            class="btnprimary mr-2"
            :class="
              JSON.stringify(causeActionObj.cause) !=
                JSON.stringify(objDummy.cause) ||
              JSON.stringify(textareas) !=
                JSON.stringify(causeActionObj.actions)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            "
            @click="cancelEditedCauseAndAction()"
          >
            Reset
          </button>
          <button
            class="btnprimary"
            :disabled="clickOnButtonForCause"
            :class="
              JSON.stringify(causeActionObj.cause) !=
                JSON.stringify(objDummy.cause) ||
              (JSON.stringify(textareas) !=
                JSON.stringify(causeActionObj.actions) &&
                textareas.length > 0)
                ? 'btnprimary'
                : 'btndisabled pointer-events-none'
            "
            @click="
              updateCauseAndAction(
                causeIdOfCauseAndAction,
                createdAtForUpdate,
                createdByForUpdate
              )
            "
          >
            Save
          </button>
        </div>
    </div>
    </div>
    </popup>
    <popup v-if="showApprovalPopup" :popUp="showApprovalPopup">
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>Approval</h1>

          <button class="float-right text-3xl" @click="onCrossbtn()">
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
    <div class='flex flex-col h-full'>
      <div class="flex-1 overflow-auto">
      <div class="popup-business">
        <div>
          <div>
            <div class="statuscontainer popupbodycontainer">
              <div class="formcontainer flex flex-col">
                <div class="row flex flex-row upperspacing">
                  <div class="w-1/2">
                    <label class="controllabel">Name of the Authority</label>
                    <!-- <Multiselect
                                                    v-model="taskObj.approval"
                                                    :options="approvingMembers"
                                                    :searchable="true"
                                                    :minChars="1"
                                                    :filterResults="true"
                                                    class="multiselect-custom mt-1"
                                                    :classes="{singleLabelText:'text-sm overflow-ellipsis overflow-hidden block whitespace-nowrap max-w-full'}"
                                                    :canClear='false'
                                                    :caret='false'
                                                    placeholder="Name"
                                                ></Multiselect> -->
                    <!-- <input
                                                    class="inputboxstyling"
                                                    placeholder="Name"
                                                    v-model="taskObj.approval"
                                                /> -->
                    <div class="inputboxstyling mt-2" disabled>
                      {{ getPersonName(presentFindingObject.reviewer) }}
                    </div>
                  </div>
                </div>
                <div class="row flex flex-row upperspacing">
                  <div class="w-full">
                    <label class="controllabel"
                      >Justification or Comments for Approving</label
                    >
                    <textarea
                      class="inputboxstyling mt-2"
                      placeholder="Comments"
                      v-model.trim="taskObj.approvalComments"
                      @input="v$.taskObj.approvalComments.$touch()" 
                      :class="{ 'is-invalid': v$.taskObj.approvalComments.$error }"
                    />
                    <div v-if="v$.taskObj.approvalComments.$error" class="text-red-500">
                      <div v-if="v$.taskObj.approvalComments.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
        </div>
      </div>
    </div>
    <div>
      <div class="border-b border-solid border-lightgrey mx-5"></div>
      <div
            class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
          >
            <button
              class="btnprimary mr-2"
              :class="
                taskObj.approvalComments == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              @click="onCancelbtnAtApproval()"
            >
              Reset
            </button>
            <button
              class="btnprimary"
              :class="
                taskObj.approvalComments == ''
                  ? 'btndisabled pointer-events-none'
                  : 'btnprimary'
              "
              :disabled="clickOnButton"
              @click="applyAuthority()"
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </popup>
    <popup v-if="showRejectPopup" >
      <template v-slot:header>
        <div
          class="flex items-center justify-between popupheadingcontainer rounded"
        >
          <h1>Justification to Reject the Approval</h1>

          <button class="float-right text-3xl" @click="onCrossbtnToCloseRejectionPopup()">
            <img src="@/assets/cancel.svg" class="cursor-pointer" />
          </button>
        </div>
      </template>
      <div class='flex flex-col h-full'>
    <div class="flex-1 overflow-auto">
      <div class="popup-business">
        <div>
            <div class="statuscontainer popupbodycontainer">
              <div class="formcontainer flex flex-col w-full upperspacing">
                    <label class="controllabel">Justification</label>
                    <textarea
                      class="inputboxstyling mt-2"
                      placeholder="Comments"
                      v-model.trim="rejectJustification.justification"
                      @input="v$.rejectJustification.justification.$touch()" 
                      :class="{ 'is-invalid': v$.rejectJustification.justification.$error }"
                    />
                    <div v-if="v$.rejectJustification.justification.$error" class="text-red-500">
                      <div v-if="v$.rejectJustification.justification.restrictCharacters300.$invalid" class="error-text text-xs">Charcter Limit is exceeded</div>
                    </div>
              </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="border-b border-solid border-lightgrey mx-5"></div>

      <div
        class="buttonposition flex justify-end items-center pb-4 pl-5 pt-4 pr-5"
      >
        <button
          class="btnprimary mr-2"
          :class="
            rejectJustification.justification == ''? 'btndisabled pointer-events-none' : 'btnprimary'"
          @click="onCancelbtnToReject()"
        >
          Reset
        </button>
        <button
          :disabled="clickOnButtonToReject"
          class="btnprimary"
          :class="
            rejectJustification.justification == ''? 'btndisabled pointer-events-none' : 'btnprimary'
          "
          @click="approveOrReject(10410)"
        >
          Save
        </button>
      </div>
    </div>
      </div>
    </popup>
  </div>
</template>
<style scoped>
.no-interaction {
    pointer-events: none;
}

.borderwidth{
  margin-left:-2px;
}
.w-80{
  width: 80%;
}
.w-20{
  width: 20%;
}
:deep(.p-select-dropdown){
  display: none !important;
}
:deep(.p-tab){
  padding: 0px 0px 5px 0px !important;
}
:deep(.p-tabpanels){
  padding-top:10px !important ;
}
:deep(.p-select.p-disabled.bg-disabledgrey),.bg-disabledgrey{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-yellow),.bg-yellow{
  background-color: #FF9900 !important;
  font-weight: 600 !important;
}
.p-select.p-disabled .p-select-dropdown{
  background-color: #a4a4a4 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-electricGreen),.bg-electricGreen{
  background-color: #8600F0 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-lightgreen),.bg-lightgreen{
  background-color: #00B050 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-darkred),.bg-darkred{
  background-color: #C00000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-error),.bg-error{
  background-color: #FF0000 !important;
  font-weight: 600 !important;
}
:deep(.p-select.p-disabled.bg-primary),.bg-primary{
  background-color: #1976D2 !important;
  font-weight: 600 !important;
}
:deep(.p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-label){
  color: white !important;
}
:deep(.p-select.p-disabled .p-select-dropdown) {
  display: none !important;
}

:deep(.p-select-dropdown-icon){
  color: white !important;
}
 @media only screen and (min-width: 320px) and  (max-width: 850px) {
    :deep(.p-tablist-tab-list){
      width: max-content !important;

    }
  }
 .table-ellipsis {
  display:-webkit-box !important;
  -webkit-line-clamp: 2 !important;
  -webkit-box-orient: vertical !important;
  overflow: hidden !important;
  text-overflow: ellipsis !important;
}
.progress {
  background: #1976d2;
  position: relative;
  border-radius: 4px;
  z-index: 2;
}
.progressbarB {
  border: 2px solid #e9e9e9;
  background: #e9e9e9;
  position: relative;
  top: -8px;
  z-index: 1;
}
.numberBorder {
  border-top: 1px solid #e9e9e9;
  border-right: 1px solid #e9e9e9;
  border-bottom: 1px solid #e9e9e9;
}
.numberNavy {
  border-left: 1px solid #152a43;
  border-left-width: 2px;
}
.fontSize10PX{
  font-size : 10px;
}
.primaryBackground {
  background-color: rgba(21, 42, 67, 0.23);
}
.paddingBottomForFindings {
  padding-bottom: 10.5px;
}
.thirtyWidthToggle::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
}
.descriptionToggle {
  height: 97%;
}
.thirtyWidthToggle::-webkit-scrollbar-thumb {
  background: transparent;
}
.thirtyWidthToggle {
  height: calc(100vh - 250px);
}
.descriptionToggle::-webkit-scrollbar {
  width: 0 !important;
  height: 0 !important;
  background: transparent;
}
.w-13{
  width:12.5%;
}
.w-87{
  width:87.5%;
}
.descriptionToggle::-webkit-scrollbar-thumb {
  background: transparent;
}
.heightFixing {
  height: calc(100vh - 220px);
  /* height : 64vh; */
}
.tabStructure {
  height: calc(100vh - 147px);
}
.custom-select {
  background-image: none;
  -moz-appearance: none;
  -webkit-appearance: none;
  appearance: none;
}
option {
  background-color: #ffffff;
  color: #000000;
  border-color: pink transparent transparent transparent;
}
.textColorWhite {
  color: white;
}
.labelWidth {
  min-width: 7rem;
}
.pendingEvidence{
    background-color: #8600f040;
}

.margining{
    margin-top : 2.5px;
}
.primary{
	color:#1976d2;
}
::-webkit-scrollbar {
	width: 3px !important;
}
.bgDisabledGrey{
	background-color: rgba(164, 164, 164, 0.2);
}
.bgError{
	background-color: rgba(255, 0, 0, 0.2);
}
.bgdarkred{
	background-color: rgba(192, 0, 0, 0.2);
}
.bgYellow{
	background-color: rgba(255, 153, 0, 0.2);
}
.bgLightGreen{
	background-color: rgba(0, 176, 80, 0.2);
}
.bgGreen{
	background-color: rgba(146, 208, 80, 0.2);
}
.bgElectricGreen{
	background-color: rgba(134, 0, 240, 0.2);
}
.bgForReview{
	background-color: rgba(8, 91, 150, 0.2);
}
.bgPrimary{
	background-color: rgba(25, 118, 210, 0.2);
}
</style>
<script lang="ts">
import { defineComponent } from "vue";
import moment from "moment";
import { emitter } from "@/main";
import popup from "@/components/popup.vue";
import Multiselect from "vue-multiselect";
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";
import { mapGetters } from "vuex";
import { toast } from "@/main";
import breadCrumbs from "@/components/breadCrumb.vue";
import commentsEditor from "@/components/commentsEditor.vue";
import safeHtml from "@/components/safeHtml.vue";
import dotsLoader from '@/components/dotsLoader.vue';
import _ from "lodash";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import Select from 'primevue/select';
import  AutoComplete  from "primevue/autocomplete";
const restrictCharacters100 = helpers.regex(/^.{0,100}$/);
const restrictCharacters300 = helpers.regex(/^.{0,300}$/);
export default defineComponent({
  props: {
    findingId: { type: [String, Number], default: null },
    modalMode: { type: Boolean, default: false },
  },
  emits: ['header-info', 'open-nested'],
  data(): any {
    return {
      selectedTabIndex: 1,
      selectedTabObj: {},
      tabHead: [
        { displayName: "Details", name: "Findings Info", id: 1 },

        { displayName: "Causes & Actions", name: "Cause&Action", id: 2 },

        { displayName: "Comments", name: "Comments", id: 3 },

        { displayName: "Approvals", name: "Approvals", id: 4 },

        { displayName: "History", name: "History", id: 5 },
      ],
      findingCategoryData: [
        {
          id: 1,
          value: "Minor",
        },
        {
          id: 2,
          value: "Major",
        },
        {
          id: 3,
          value: "OFI",
        },
        {
          id: 4,
          value: "Observation",
        },
      ],
      findingStatusData: [
        {
          id: 10401,
          status: "Open",
        },
        {
          id: 10421,
          status: "For Review",
        },
        {
          id: 10402,
          status: "In Progress",
        },
        {
          id: 10406,
          status: "Partial",
        },
        {
          id: 10403,
          status: "Completed",
        },
        {
          id: 10408,
          status: 'Approval'
        },
        {
          id: 10414,
          status: 'For Review'
        },
        {
          id: 10418,
          status: "Terminated",
        },
      ],
      terminateArray: [
        {
          id: 10418,
          status: "Terminated",
        },
      ],
      statuses:[],
      tabDataLoading:false,
      locationObject: [],
      userOptions: [],
      titleLength: 60,
      personObj: "",
      oldComments: true,
      oldHistory: true,
      comment: "",
      comments: [],
      orgUsersList: [],
      allOrgUsers: [],
      optionsUserArray: [],
      btnDisabled: true,
      allEntities: [],
      causesLength: false,
      presentFindingObject: {},
      routesArray: [],
      users: [],
      showApprovalPopup: false,
      finalFindingsTasks: [],
      showCausePopup: false,
      taskObj: {
        approvalComments: "",
      },
      // navIndexNums: { name: "", index: "" },
      approvingMembers: [],
      v$: useVuelidate(),
      causeActionObj: {
        cause: "",
        actions: [],
      },
      textareas: [{ action: "" ,targetDate:""}] as { action: string ,targetDate:string}[],
      textareasDummy: [{ action: "",targetDate:"" }],
      textareasDummyForActions: [],
      causeActionObjDummy: [],
      causeAndActionSaved: false,
      validationErrors: [],
      causeActionTableData: {},
      selectCauseObj: "",
      statusCodeOfFinding: "",
      workLogObject: [],
      TaskDetailsDropDown: {
        findingStatus: "",
        assigneeDropDown: "",
      },
      approvalObj: {},
      objDummy: {},
      editVariable: false,
      disableSendApprovalButton: false,
      textareaEditDummy: [],
      showRejectPopup : false,
      rejectJustification:{
        justification : ''
      },
      clickOnButton: false,
      clickOnButtonForCause: false,
      clickOnButtonToReject : false,
      newAssignee : '',
      matchedEntity:false,
    };
  },
  validations() {
    return {
      causeActionObj: {
        cause: { required, restrictCharacters100 },
      },
      textareas: {
        $each: helpers.forEach({
          action: { required },
          targetDate: { required },
        }),
      },
      taskObj: {
        approvalComments: {restrictCharacters300},
      },
      rejectJustification:{
        justification : {restrictCharacters300},
      },
    };
  },
  computed: {
    ...mapGetters({ userInfo: "userInfo" ,dbPriority :'dbPriority',dbFrequency:'dbFrequency'
       ,dbSeverity:'dbSeverity',dbLikelihood: 'dbLikelihood',dbOperations: 'dbOperations',
            dbLegal: 'dbLegal',
            dbFinancial: 'dbFinancial',
            dbTechnical: 'dbTechnical',dbBussiness: 'dbBussiness',dbOverAllImpact:'dbOverAllImpact'
    }),
    currentFindingId(): any {
      return this.findingId || this.$route.params.findingId;
    },
    findingFileEvidences(): any[] {
      const files = this.presentFindingObject?.files;
      if (!Array.isArray(files)) return [];
      return files.filter((doc: any) => (doc?.evidenceType || 'file') !== 'url');
    },
    findingLinkEvidences(): any[] {
      const files = this.presentFindingObject?.files;
      if (!Array.isArray(files)) return [];
      return files.filter((doc: any) => doc?.evidenceType === 'url');
    },
  },
  components: {
    breadCrumbs,
    popup,
    Multiselect,
    commentsEditor,
    safeHtml,
		dotsLoader,
    Tabs,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    AutoComplete,
    Select
  },
  methods: {
  colorLabelText(value: any) {
      if (value == 1) {
          return ["text-lightgreen font-semibold"];
      } else if (value == 2) {
          return ["text-green font-semibold"];
      } else if (value == 3) {
          return ["text-yellow font-semibold"];
      } else if (value == 4) {
          return ["text-error font-semibold"];
      } else if (value == 5) {
          return ["text-darkred font-semibold"];
      }
    },
    openCalendar(event: any) {
      event.target.showPicker();
    },
    bgColor(value: any) {
          if (value == 1) {
              return ['bg-veryLowColor border-solid border border-lightgreen'];
          } else if (value == 2) {
              return ['bg-lowColor border-solid border border-green'];
          } else if (value == 3) {
              return ['bg-moderateColor border-solid border border-yellow'];
          } else if (value == 4) {
              return ['bg-highColor border-solid border border-error'];
          } else if (value == 5) {
              return ['bg-veryHighColor border-solid border border-darkred'];
          }
      },
      colorLabel(value: any) {
          if (value == 1) {
              return ['text-lightgreen font-semibold text-xs'];
          } else if (value == 2) {
              return ['text-green font-semibold text-xs'];
          } else if (value == 3) {
              return ['text-yellow font-semibold text-xs'];
          } else if (value == 4) {
              return ['text-error font-semibold text-xs'];
          } else if (value == 5) {
              return ['text-darkred font-semibold text-xs'];
          }
      },
      treatmentTypeBgColor(id:any){
			if(id==10403){
				return ["bg-veryLowColor border-solid border border-lightgreen"];
			}
			else if(id ==10419){
				 return ["bg-lowColor border-solid border border-green"];
			}
			else if(id==10405){
				return  ['bg-veryLowColor border-solid border border-lightgreen'];
			}
			else if(id==10424){
				return ["bg-moderateColor border-solid border border-yellow"];
			}
      else if(id==10425){
				return ["bg-resetBlue/10 border-solid border border-resetBlue"];
			}
		},
    treatmentTypeTextColor(id:any){
			if(id==10403){
				return ["text-lightgreen font-semibold"];
			}
			else if(id ==10419){
				  return ["text-green font-semibold"];
			}
			else if(id ==10405){
				return ['text-lightgreen font-semibold'];
			}
			else if(id==10424){
				return ["text-yellow font-semibold"];
			}
      else if(id==10425){
				return ["text-resetBlue font-semibold"];
			}
		},
    presentTask(dataInfo: any) {
      const item = this.treatmentTypeStatus.find((data: any) => data.id == dataInfo);
      return item ? item.label : 'N/A';
    },
      getLablesInfo(data:any,id:any){
			if(id==1){
				let a = this.dbBussiness.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==2){
				let a = this.dbFinancial.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==3){
				let a = this.dbOperations.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==4){
				let a = this.dbLegal.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}if(id==5){
				let a = this.dbLikelihood.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
			if(id==6){
				let a = this.dbOverAllImpact.find((obj: any) =>{
			  return obj.value == data});
              return (data && typeof data === 'number') ? a.key : '';
			}
		},
    getRiskOwnerLabel(userId:any) {

			const user = this.optionsUserArray.find(
				(u: any) => u.value === userId
			);

			return user ? user.label : 'N/A';
		},
    isAddDisabled(permission:any) {
      try {
				if (!this.userInfo || !this.userInfo.organisationType) {
					return true;
				}
        // if (this.userInfo.organisationType !== 10701) {
        //     return true;
        // }
        return this.hasPermission(this.userInfo, 10001, 10110, permission);
      } catch (e) {
          console.error("Permission check failed:", e);
          return true;
      }
	  },
    treatmentSummaryData(actionType:any){
      if(actionType!='' && actionType==10424){
				if(this.presentFindingObject?.riskInformation[0]?.transferSummary && this.presentFindingObject?.riskInformation[0]?.transferSummary!=undefined){
					return this.presentFindingObject?.riskInformation[0]?.transferSummary
				}
				else{
					return 'N/A'
				}
			}
			else if(actionType!='' && actionType==10419){
				if(this.presentFindingObject?.riskInformation[0]?.avoidSummary && this.presentFindingObject?.riskInformation[0]?.avoidSummary!=undefined){
					return this.presentFindingObject?.riskInformation[0]?.avoidSummary
				}
				else{
					return 'N/A'
				}
			}
			else if(actionType!='' && actionType==10403){
				if(this.presentFindingObject?.riskInformation[0]?.acceptSummary && this.presentFindingObject?.riskInformation[0]?.acceptSummary!=undefined){
					return this.presentFindingObject?.riskInformation[0]?.acceptSummary
				}
				else{
					return 'N/A'
				}
			}
      else if(actionType!='' && actionType==10425){
        if(this.presentFindingObject?.riskInformation[0]?.moniteredSummary && this.presentFindingObject?.riskInformation[0]?.moniteredSummary!=undefined){
					return this.presentFindingObject?.riskInformation[0]?.moniteredSummary
        }
        else{
          return 'N/A'
        }
			}
			else{
				return 'N/A'
			}
			
		},
    formatFileAttachedTime(time: any) {    
      let now = moment(time);
      return now.format("DD-MM-YYYY");
    },
    getS3KeyFromUrl(fileUrl: string) {
      try {
        const url = new URL(fileUrl);
        return url.pathname.startsWith('/')
          ? url.pathname.slice(1)
          : url.pathname;
      } catch (e) {
        return '';
      }
    },

    getFindingEvidenceFileExt(doc: any) {
      if (!doc?.url || doc.evidenceType === 'url') return '';
      try {
        const path = new URL(doc.url).pathname;
        return (path.split('.').pop() || '').toLowerCase();
      } catch (e) {
        return (String(doc.url).split('.').pop() || '').toLowerCase();
      }
    },
    async openEvidenceFile(doc: any) {
      const fileUrl = typeof doc === 'string' ? doc : doc?.url;
      if (!fileUrl) return;

      if (typeof doc !== 'string' && doc?.evidenceType === 'url') {
        window.open(fileUrl, '_blank', 'noopener,noreferrer');
        return;
      }

      const key = this.getS3KeyFromUrl(fileUrl);
      if (!key) {
        return;
      }

      try {
        const response = await this.$http.post(
          `${process.env.VUE_APP_FILE_API}/presignedurl/v3`,
          { key }
        );

        const signedUrl =
          typeof response.data === 'string'
            ? response.data
            : response.data?.url;

        if (signedUrl) {
          window.open(signedUrl, '_Self' ,'noopener,noreferrer');
        }
      } catch (err) {
        console.error(err);
      }
    },
    hasPermission(userInfo:any, appId:any, entityId:any, permissionId:any) {
      if (!userInfo || !userInfo.apps) return false;
      const app = userInfo.apps.find((a:any) => a.appId === appId);
      if (!app) return false;
      const entity = app.entities?.find((e:any) => e.entityId === entityId);
      if (!entity) return false;
      return entity.permissions?.includes(permissionId) || false;
	  },
    routeToTask(){
      if(this.presentFindingObject!=undefined && this.presentFindingObject!='' && Object.keys(this.presentFindingObject).includes('taskId') && this.presentFindingObject.taskId!=undefined){
        if (this.modalMode) {
          this.$emit('open-nested', {
            view: 'crTask',
            title: 'Task',
            params: { taskId: this.presentFindingObject.taskId },
          });
        } else {
          this.$router.push({ name: 'crTaskEdit', params: { taskId:  this.presentFindingObject.taskId } });
        }
        // this.$route.
      }
      else{
        toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
        
      }
    },
  colorLabelBg(value: any) {
      if (value == 1) {
          return ["bg-veryLowColor border-solid border border-lightgreen"];
      } else if (value == 2) {
          return ["bg-lowColor border-solid border border-green"];
      } else if (value == 3) {
          return ["bg-moderateColor border-solid border border-yellow"];
      } else if (value == 4) {
          return ["bg-highColor border-solid border border-error"];
      } else if (value == 5) {
          return ["bg-veryHighColor border-solid border border-darkred"];
      }
    },
  getFindingSeverityValue(obj: any) {
      const raw = obj?.finding_severity ?? obj?.findingSeverity;
      if (raw == null || raw === '') return null;
      if (typeof raw === 'object') {
        return raw.value != null && raw.value !== '' ? Number(raw.value) : null;
      }
      const numeric = Number(raw);
      return Number.isFinite(numeric) ? numeric : null;
    },
  getFindingSeverityLabel(obj: any) {
      const raw = obj?.finding_severity ?? obj?.findingSeverity;
      if (raw == null || raw === '') return 'N/A';
      if (typeof raw === 'object' && raw.label != null && String(raw.label).trim() !== '') {
        return String(raw.label);
      }
      return 'N/A';
    },
  isDisabledFindingSeverityLabel(label: any) {
      const text = String(label || '').trim().toUpperCase();
      return text === 'N/A' || text === 'NONE';
    },
  findingSeverityChipBg(obj: any) {
      const label = this.getFindingSeverityLabel(obj);
      if (this.isDisabledFindingSeverityLabel(label)) {
        return ['bg-lightgrey border-solid border border-lightgrey'];
      }
      const value = this.getFindingSeverityValue(obj);
      if (value == 1) return ['bgLightGreen border-solid border border-lightgreen'];
      if (value == 2) return ['bgGreen border-solid border border-green'];
      if (value == 3) return ['bgYellow border-solid border border-yellow'];
      if (value == 4) return ['bgError border-solid border border-error'];
      if (value == 5) return ['bgdarkred border-solid border border-darkred'];
      return ['bg-lightgrey border-solid border border-lightgrey'];
    },
  findingSeverityChipText(obj: any) {
      const label = this.getFindingSeverityLabel(obj);
      if (this.isDisabledFindingSeverityLabel(label)) {
        return ['text-gray text-xs font-semibold'];
      }
      const value = this.getFindingSeverityValue(obj);
      if (value == 1) return ['text-lightgreen text-xs font-semibold'];
      if (value == 2) return ['text-green text-xs font-semibold'];
      if (value == 3) return ['text-yellow text-xs font-semibold'];
      if (value == 4) return ['text-error text-xs font-semibold'];
      if (value == 5) return ['text-darkred text-xs font-semibold'];
      return ['text-gray text-xs font-semibold'];
    },
  getProirityLabel(val:any){    
      if (val === 'N/A') { 
          return ''; 
      } else {
        let a = this.dbPriority.find((obj: any) => obj.value == val);        
        return (val && typeof val === 'number') ? a.key : '';
      }
    },
    // getComment(obj: any){
    //     if(obj == undefined){
    //         console.log("no additional info")
    //     }

    //     else{
    //         if(Object.keys(obj).includes('comment')){
    //             return obj.comment
    //         } else if(Object.keys(obj).includes('cause')){
    //             return obj.cause
    //         } else if(Object.keys(obj).includes('actions')){
    //             return obj.actions
    //         }
    // }
    // },
    getLocationNameForSystem(dept:any){
    if(dept!=undefined){
      let d = this.allEntities.find((Dept:any)=>Dept.departments && Dept.departments.includes(dept));
      return d ? d.entityDisplayName : 'N/A'
      
    }
     const matched = this.locationObject.find((obj: any) => obj.entityType === 1);
      return matched ? matched.label : 'N/A';
  },
  async getFindingsStatuses(){
    let appId='10001';
    let entityId='10110';
    await this.$http.get(`${process.env.VUE_APP_AUTH_API}/${appId}/${entityId}/statuses`).then((result: any) => {				
      this.statuses = result.data.statuses
      this.treatmentTypeStatus=result.data.treatmentTypes

    });
	},
    getEntity(id :any){
      let entity:any
      if(id === 'Global'){
        // console.log('global 2222 or nulll,',id)
        return 'Global'
      }
     else if(id != undefined || id != null || !(typeof id === 'object')){
        entity = this.allEntities.find((data:any)=> { return data._id == id})
        // console.log('enityyyy',entity)
        if(entity != undefined){
          return entity.entityDisplayName
        } else {
          return 'N/A'
        }
      } else if((typeof id === 'object')){
        let a:any = this.allEntities.find((data:any)=> { return data._id == id})
        if(a != undefined){
          return a.entityName
        } else {
          return 'N/A'
        }
      } else {
        // console.log('global or nulll,',id)
        return 'N/A'
      }
    },
    showPopupToReject(){
      this.showRejectPopup = true;
      this.taskObj.approvalComments = "";
    },
    extractInitials(name: any) {
      if(name!=undefined){
        const names = name.split(" ");
      return names
        .map((name: any) => name[0])
        .join("")
        .toUpperCase();
      }
    },
    getPerson(person: any) {
      this.personObj = this.orgUsersList.find((user: any) => {
        return user._id == person;
      });
      if (this.personObj == undefined) {
        return "";
      } else {
        return this.personObj.name;
      }
    },
    getTeamName(team: any) {
      let teamObj = this.users.find((obj: any) => {
        return obj._id == team;
      });
      if (teamObj == undefined) {
        return "";
      } else {
        return teamObj.displayName;
      }
    },
    getDeptEntity(teamId: any) {
      let presentteamObject: any = this.users.find((obj: any) => {
        return obj._id == teamId;
      });
      if (presentteamObject != undefined && presentteamObject.entityType == 20301) {
        // let entityObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
        return presentteamObject ? presentteamObject.entityName : 'N/A';
      } else if(presentteamObject != undefined && presentteamObject.entityType == 20303){
        return presentteamObject ? presentteamObject.entityDisplayName : 'N/A';
      } else {
        return 'N/A'
      }
    },
    getLocation(teamId: any) {
      let presentteamObject: any = this.users.find((obj: any) => {
        return obj._id == teamId;
      });
      if (presentteamObject != undefined && presentteamObject.entityType == 20301) {
        let entityObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
        return entityObj ? 'Global': 'N/A';
      } else {
        if (
          this.presentFindingObject.entity == undefined ||
          this.presentFindingObject.entity == null
        ) {
          return "N/A";
        } else {
          return this.getLocationName(
            this.presentFindingObject.entity[0].entity
          );
        }
      }
    },
    getLocationName(locationId: any, entitytypecodeid: any) {
       if(entitytypecodeid == 20301){
        // let locationObj = this.allEntities.find((entity: any)=>{return entity.entityType == 1})
        // return locationObj.entityName
        return 'Global'
        }else if(locationId == null){
          return 'N/A'
        }else if(entitytypecodeid != 20301){
        let locationObj = this.locationObject.find((obj: any) => {
          return obj.value == locationId;
        });
        if (locationObj == undefined) {
          let empty = "N/A";
          return empty;
        } else {
          return locationObj.label;
        }
      }
    },
    getStatusLabel(num: any) {
      let result = this.statuses.find((obj: any) => {
        return obj.id == num;
      });
      return result!=undefined?result.label:'N/A';
    },
    asyncFind(query: any) {
      query=query.query.trim();
      if (query == "") {
        this.userOptions = [];
      } else if (query.length >= 1) {
        this.userOptions = this.optionsUserArray.filter((obj: any) => {
          return obj.label.toLowerCase().includes(query.toLowerCase());
        });
      }
    },
    async updateFindingStatus(status: any) {
      let payload: any = { statusCode: status };
      await this.updatePresentFinding(payload, 5);
    },
    async updateAssignedMember(obj: any) {
      let payload: any = { assignee: obj.value };
      await this.updatePresentFinding(payload, 4);
      if(this.presentFindingObject.assignee != undefined ){
        this.newAssignee = this.presentFindingObject.assignee
      }
    },
    async toggleTabs(obj: any) {
      this.selectedTabIndex = obj.id;
      this.selectedTabObj = obj;
      //sessionStorage.setItem('selectedTab', obj.id);
      await this.getPresentFindingObject()
      await this.getFindingHistoryObject()
    },
    sortComments() {
      this.oldComments = !this.oldComments;
      if (this.presentFindingObject.comments != undefined) {
        this.presentFindingObject.comments.sort().reverse();
      }
    },

    sortHistory() {
      this.oldHistory = !this.oldHistory;
      if(this.workLogObject.findingHistory != undefined){
          this.workLogObject.findingHistory.sort().reverse();
      }
    },
    onCrossbtn() {
      this.showApprovalPopup = false;
      this.taskObj.approvalComments = "";
    },
    onCrossbtnToCloseRejectionPopup(){
      this.showRejectPopup = false;
      this.onCancelbtnToReject();
    },
    onCrossbtnForCauseAndAction() {
      this.showCausePopup = false;
        this.cancelCauseAction();
    },
    checkReviewer(){
      if(this.presentFindingObject.reviewer == this.userInfo._id || this.userInfo?.role_id!=10217){
        return true
      } else if(this.presentFindingObject.reviewer == undefined || this.presentFindingObject.reviewer == null){
        return 'N/A'
      } else {
        return false
      }
    },
    getFindingRelatedToFieldLabel(obj: any) {
      if (!obj || obj.findingRelatedTo == null || obj.findingRelatedTo === '') {
        return 'CID / KPI ID';
      }
      return Number(obj.findingRelatedTo) === 2 ? 'KPI ID' : 'CID';
    },
    getFindingRelatedToDisplay(obj: any) {
      if (!obj || obj.findingRelatedTo == null || obj.findingRelatedTo === '') {
        return 'N/A';
      }
      if (Number(obj.findingRelatedTo) === 2) {
        // Prefer enriched human-readable KPI ID (kpi.kpi_id), then resolve from task kpis
        if (obj.findingRelatedToLabel && String(obj.findingRelatedToLabel).trim() !== '' && obj.findingRelatedToLabel !== 'N/A') {
          return String(obj.findingRelatedToLabel);
        }
        const kpiRef = obj.kpi_id ?? obj['kpi._id'] ?? obj.kpi?._id ?? obj.controlorKpi;
        const kpis = obj?.complianceDetails?.[0]?.kpis || obj?.kpis || [];
        if (kpiRef != null && Array.isArray(kpis) && kpis.length) {
          const matched = kpis.find(
            (k: any) =>
              k._id == kpiRef ||
              k._id?.toString() === String(kpiRef) ||
              String(k.kpi_id) === String(kpiRef)
          );
          if (matched?.kpi_id != null && String(matched.kpi_id).trim() !== '') {
            return String(matched.kpi_id);
          }
        }
        return kpiRef != null && String(kpiRef).trim() !== '' ? String(kpiRef) : 'N/A';
      }
      const clientUniqueId =
        obj?.complianceDetails?.[0]?.clientUniqueId ??
        obj?.clientUniqueId;
      return clientUniqueId != null && String(clientUniqueId).trim() !== ''
        ? String(clientUniqueId)
        : 'N/A';
    },
    getFindingLinkFieldLabel(obj: any) {
      if (obj?.linkFieldLabel) {
        return obj.linkFieldLabel;
      }
      if (obj?.findingRelatedTo == null || obj?.findingRelatedTo === '') {
        return 'Control / KPI';
      }
      return Number(obj.findingRelatedTo) === 2 ? 'KPI' : 'Control';
    },
    getFindingLinkDisplay(obj: any) {
      if (obj?.linkDisplay) {
        return obj.linkDisplay;
      }
      if (!obj || obj.findingRelatedTo == null || obj.findingRelatedTo === '') {
        return 'N/A';
      }
      if (Number(obj.findingRelatedTo) === 2) {
        return 'N/A';
      }
      return obj?.complianceDetails?.[0]?.controlTitle || obj?.controlTitle || 'N/A';
    },
    groupBy(arr: any, keyName: any) {
      return arr.reduce((group: any, product: any) => {
          const keyValue = product[keyName];
          group[keyValue] = group[keyValue] ?? [];
          group[keyValue].push(product);
          return group;
      }, {});
    },
    getCategory(num: any) {
      let result = this.findingCategoryData.find((obj: any) => {
        return obj.id == num;
      });
      return result.value;
    },
    onCancelbtnAtApproval() {
      this.taskObj.approvalComments = "";
    },
    onCancelbtnToReject(){
      this.rejectJustification.justification = "";
    },
    openCausePopup() {
      this.editVariable = false;
      this.showCausePopup = true;
    },
    openApprovalpopup() {
      this.showApprovalPopup = true;
    },
    clearComment() {
      this.comment = "";
      this.btnDisabled = true;
    },
    formatTime(time: any) {
      let now = moment(time);
      return now.format("DD-MM-YYYY, HH:mm:ss");
    },
    getBorder() {
      return `numberBorder numberNavy`;
    },
    handleInput() {
      this.btnDisabled = this.comment.length === 0;
    },
    changeBackground() {
      if (this.TaskDetailsDropDown.findingStatus == 10401) {
        return "bg-disabledgrey textColorWhite";
      } else if (this.TaskDetailsDropDown.findingStatus == 10421) {
        return "bg-yellow textColorWhite";
      } else if (this.TaskDetailsDropDown.findingStatus == 10402) {
        return "bg-electricGreen textColorWhite";
      } else if (this.TaskDetailsDropDown.findingStatus == 10406) {
        return "bg-primary textColorWhite";
      } else if (this.TaskDetailsDropDown.findingStatus == 10403) {
        return "bg-lightgreen textColorWhite";
      } else if (this.TaskDetailsDropDown.findingStatus == 10418) {
        return "bg-error textColorWhite";
      } else {
        return "";
      }
    },
    async getallEntities() {
      this.locationObject = [];
      let result: any;
      await this.$http
        .get(
          `${process.env.VUE_APP_ORG_API}/api/org/businessEntities/getall`
        )
        .then((res: any) => {
            this.allEntities = res.data;
            result = res.data;
        });
      for (var i = 0; i < result.length; i++) {
        this.locationObject.push({
          label: result[i].entityDisplayName,
          value: result[i]._id,
          entityType:result[i].entityType
        });
      }
    },
    async getAllTeams() {
      this.teamObject = [];
      await this.$http
        .get(`${process.env.VUE_APP_ORG_API}/departments/get`)
        .then((res: any) => {
          this.users = res.data;
        });
      for (var i = 0; i < this.users.length; i++) {
        this.teamObject.push({
          label: this.users[i].teamName,
          value: this.users[i]._id,
        });
      }
    },
    async getallUsers() {
      await this.$http
        .get(`${process.env.VUE_APP_ORG_API}/users/getAll`)
        .then((res: any) => {
          this.orgUsersList = res.data;
          this.allOrgUsers = this.orgUsersList;
          // this.orgUsersList = this.orgUsersList.filter((user: any) => {
          //   return user.isActive == true;
          // });
          for (var i = 0; i < this.orgUsersList.length; i++) {
            this.optionsUserArray.push({
              label: this.orgUsersList[i].name,
              value: this.orgUsersList[i]._id,
            });
            // if(this.userInfo._id != this.orgUsersList[i]._id){
            this.approvingMembers.push({
              label: this.orgUsersList[i].name,
              value: this.orgUsersList[i]._id,
            });
            // }
          }
        });
    },
    goToActionTasks(taskId:any){
      if (this.modalMode) {
        this.$emit('open-nested', {
          view: 'actionTask',
          title: 'CAPA Task',
          params: { taskId: taskId, findingId: this.currentFindingId },
        });
      } else {
        this.$router.push({ name: 'actionTask', params: { taskId: taskId , findingId : this.currentFindingId } });
      }
    },
    // rejectingTheApprovalOnSave(statusCode: any){

    // },
    async approveOrReject(statusCode: any) {
      this.clickOnButtonToReject = true;
      const payload: any = {
        statusCode: statusCode,
        rejectJustification:this.rejectJustification.justification,
        updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        updatedBy: this.userInfo._id,
      };
      try{
        await this.$http
        .post(
          `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/update/approval`,
          payload
        )
        .then((result: { data: any }) => {
          // console.log("here it ISSSSSS");
        });
      if (statusCode == 10403) {
        toast.info(`Approval Approved`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
        const workflowpayload = [
          {
            findingId: this.currentFindingId,
            createdBy: this.userInfo._id,
            createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
          },
        ];
        await this.$http
          .post(
            `${process.env.VUE_APP_WORKFLOW_API}/api/org/trigger/workflow/${process.env.VUE_APP_CR_FINDING_WORKFLOW_ID}/compliance/findings/task`,
            workflowpayload
          )
          .then((result: { data: any }) => {
            // console.log("here it ISSSSSS, the workflowpayload");
          });
      } else if (statusCode == 10410) {
        toast.info(`Approval Rejected`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      }
      }catch (e) {
				toast.error('error', {
					timeout: 1000,
					closeOnClick: true,
					closeButton: 'button',
					icon: true
				});
			} finally {
				this.clickOnButtonToReject = false;
			}
      // await this.getAllFindingsTasks();
      await this.onCrossbtnToCloseRejectionPopup()
      await this.getPresentFindingObject();
      await this.getFindingHistoryObject();
    },
    async deleteCauseAndAction(causeId : any, cause : any) {
      if (this.approvalObj.statusCode != 10403) {
        const payload: any = {
                cause : cause,
                updatedBy: this.userInfo._id,
                updatedAt: moment().format('YYYY-MM-DD HH:mm:ss'),
            };
        await this.$http
          .post(
            `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/cause/${causeId}/delete`,payload
          )
          .then(async (result: any) => {

            await this.getPresentFindingObject();
            await this.getFindingHistoryObject();
            toast.info(`Deleted Successfully`, {
            timeout: 1000,
            closeOnClick: true,
            closeButton: "button",
            icon: true,
          });
          });
      }
    },
    editCauseAndAction(obj: any) {
      if (this.approvalObj.statusCode == 10403) {
        this.showCausePopup = false;
      } else {
        this.editVariable = true;
        this.objDummy = { ...obj };
        this.causeIdOfCauseAndAction = this.objDummy.causeId;
        this.createdAtForUpdate = this.objDummy.createdAt;
        this.createdByForUpdate = this.objDummy.createdBy;
        delete this.objDummy.createdAt;
        delete this.objDummy.createdBy;
        delete this.objDummy.causeId;
        this.showCausePopup = true;
        let actions = this.objDummy.actions;
        this.causeActionObj.cause = this.objDummy.cause;
        this.causeActionObj.actions = [...actions];
        this.textareaEditDummy = [...actions];
        this.textareas = [];
        this.objDummy.actions.map((obj: any) => {
          this.textareas.push({ ...obj });
        });
        // this.textareaEditDummy = [...this.objDummy.actions]
        // this.causeActionObj.actions = this.objDummy.actions
      }
    },
    cancelEditedCauseAndAction() {
      this.v$.$reset();
      this.causeActionObj.cause = this.objDummy.cause;
      this.textareas = [];
      this.objDummy.actions.map((obj: any) => {
        this.textareas.push({ ...obj });
      });
      // this.textareas = this.objDummy.actions
    },
    async clickOnReject() {
      const payload: any = {
        statusCode: 10410,
        updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        updatedBy: this.userInfo._id,
      };
      await this.$http
        .post(
          `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/update/approval`,
          payload
        )
        .then((result: { data: any }) => {
          // console.log("here it ISSSSSS");
        });
    },
    async getAllFindingsTasks(){
            await this.$http
                .get(`${process.env.VUE_APP_MONITOR_API}/finding/${this.currentFindingId}/capa/tasks`)
                .then((result: any) => {        
                    this.findingsTasksArray = result.data
                   this.finalFindingsTasks =  this.groupBy(this.findingsTasksArray,'cause')
                })
        },
    async applyAuthority() {
      this.showApprovalPopup = false;
      this.clickOnButton = true;
      let dummyTaskObj:any = _.cloneDeep(this.taskObj);
      const payload: any = {
        assignee: this.presentFindingObject.reviewer,
        comments: dummyTaskObj.approvalComments,
        createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
        createdBy: this.userInfo._id,
      };

      await this.updatePresentFinding(payload, 3);
      await this.getPresentFindingObject();
      dummyTaskObj.approvalComments = "";
    },
    async getFindingHistoryObject() {
      // /api/org/finding/6684f413e3794c5eb46ee16f/history/get

      await this.$http
        .get(
          `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/history/get`
        )
        .then((result: any) => {
          const mainObject = result.data;
          this.workLogObject = mainObject;
        });
        if(this.workLogObject.findingHistory != undefined){
          this.workLogObject.findingHistory.sort().reverse();
      }
    },

    async addComment() {
      if (this.comment.trim() !== "") {
        const payload: any = {
          comment: this.comment,
          createdAt: new Date(),
          createdBy: this.userInfo._id,
        };

        await this.updatePresentFinding(payload, 2);
        if (this.presentFindingObject.comments != undefined) {
          this.presentFindingObject.comments.sort().reverse();
        }
        this.comment = "";
        // await this.updateFindingTask(1, newComment);
        // this.comments.push(newComment);
        this.comment = "";
        this.btnDisabled = true;
      }
    },

    async getPresentFindingObject() {
      try{
        this.tabDataLoading = true
      await this.$http
        .get(
          `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/get`
        )
        .then((result: any) => {
          this.presentFindingObject = result.data[0];          

          if(this.presentFindingObject.causes==undefined|| this.presentFindingObject.causes.length == 0){
                this.causesLength = true;
            }else {
                this.causesLength = false;
          }

          if (
            this.presentFindingObject.approvals != null ||
            this.presentFindingObject.approvals != undefined
          ) {
            const lastApproval =
              this.presentFindingObject.approvals[
                this.presentFindingObject.approvals.length - 1
              ];
            this.approvalObj = lastApproval;
          } else {
            this.approvalObj = {};
          }
        });
        await this.getAllFindingsTasks()
      this.TaskDetailsDropDown.findingStatus = this.presentFindingObject.statusCode;
    //   let teamLeaderObj: any 
    //         if(Object.keys(this.presentTaskObject).includes('assignee') && this.presentTaskObject.assignee !== undefined){
    //           teamLeaderObj = this.optionsUserArray.find((obj: any) => {
    //             return obj.value == this.presentTaskObject.assignee;
    //           });
    //         } else{
    //           teamLeaderObj = this.optionsUserArray.find((obj: any) => {
    //             return obj.value == this.presentComplianceObject.teamLeader;
    //           });
    //         }
    //         this.presentComplianceObject.teamLeader = teamLeaderObj;
      if (Object.keys(this.presentFindingObject).includes('assignee') && this.presentFindingObject.assignee != undefined) {
        let userObj: any = this.optionsUserArray.find((obj: any) => {
          return obj.value == this.presentFindingObject.assignee;
        });
        this.presentFindingObject.assignee = userObj;
      } else {
        let userObj: any = this.optionsUserArray.find((obj: any) => {
          return obj.value == this.presentFindingObject.reviewer;
        });
        this.presentFindingObject.assignee = userObj;
      }
      } catch (error){
        toast.error(`Error`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
      } finally{
        this.tabDataLoading = false
      }
      
    },
    getPersonName(person: any) {
			let personObj = this.orgUsersList.find((user: any) => {
				return user._id == person;
			});
			if (personObj == undefined && person==undefined) {
				return '';
			} else if(person!=undefined && personObj==undefined){								
				if(this.userInfo._id==person){					
					return this.userInfo.name;
				}
				else{
					return '';
				}
			}else {
				return personObj.name;
			}
		},
    getAllPersonName(person: any) {
      let personObj = this.allOrgUsers.find((user: any) => {
        return user._id == person;
      });
      if (personObj == undefined) {
        return "";
      } else {
        return personObj.name;
      }
    },
    async updateCauseAndAction(causeId: any, createdAt: any, createdBy: any) {
      this.v$.$touch();
      let booleanValue = false;
       this.clickOnButtonForCause = true;
      if (this.textareas.length > 0) {
        booleanValue = !this.textareas.some((obj: any) => obj.action === "");
        if (booleanValue) {
          this.causeActionObj.actions = [...this.textareas];
          const payload: any = {
            cause: this.causeActionObj.cause,
            actions: this.causeActionObj.actions,
            createdBy: createdBy,
            createdAt: createdAt,
            updatedBy: this.userInfo._id,
            updatedAt: moment().format("YYYY-MM-DD HH:mm:ss"),
          };
          try{
              await this.$http
            .post(
              `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/cause/${causeId}/update`,
              payload
            )
            .then(async (result: any) => {
              toast.info(`Updated`, {
                timeout: 1000,
                closeOnClick: true,
                closeButton: "button",
                icon: true,
              });
              await this.getPresentFindingObject();
              await this.getFindingHistoryObject();
            });
          }catch (e) {
              toast.error('error', {
                timeout: 1000,
                closeOnClick: true,
                closeButton: 'button',
                icon: true
              });
            } finally {
              this.clickOnButtonForCause = false;
            }
          // this.cancelEditedCauseAndAction()
          this.showCausePopup = false;
        }
      }
      // this.cancelEditedCauseAndAction()
    },
    async saveCauseAction() {
      this.v$.$touch();
      if (!this.v$.causeActionObj.$invalid && !this.v$.textareas.$invalid) {
        this.clickOnButtonForCause = true;
        this.causeAndActionSaved = true;
        this.causeActionObj.actions = [...this.textareas];
        const payload: any = {
          cause: this.causeActionObj.cause,
          actions: this.causeActionObj.actions,
          createdAt: moment().format("YYYY-MM-DD HH:mm:ss"),
          createdBy: this.userInfo._id,
        };
        await this.updatePresentFinding(payload, 1);
        // this.causeActionObj = {}
        // this.showCausePopup = false
        this.onCrossbtnForCauseAndAction();
        // this.cancelCauseAction()
      }
    },
    async updatePresentFinding(payload: any, type: any) {
      // delete payload.additionalInfo;
      payload.createdBy = this.userInfo._id;
      payload.createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
      if (type == 1) {
        payload.cause = payload.cause;
        payload.updatedBy = this.userInfo._id;
        payload.updatedAt = new Date();
        // payload.additionalInfo.cause = payload.cause;
      } else if (type == 2) {
        payload.comment = payload.comment;
        payload.updatdBy = this.userInfo._id;
        payload.updatedAt = new Date();
        // payload.additionalInfo.comment = payload.comment;
      } else if (type == 3) {
        payload.justification = payload.justification;
        // payload.additionalInfo.justification = payload.justification;
    //   }  else if (type == 4) {
        // payload.assignee = payload.assignee;
        // payload.additionalInfo.assignee = payload.assignee;
      } else if (type == 5) {
        payload.createdAt = moment().format("YYYY-MM-DD HH:mm:ss");
        payload.createdBy = this.userInfo._id;
        payload.previousStatus = this.presentFindingObject.statusCode;
        payload.statusCode = payload.statusCode;
        payload.updatedStatus = payload.statusCode;
        // payload.additionalInfo.previousStatus = this.presentFindingObject.statusCode;
        // payload.additionalInfo.updatedStatus = payload.statusCode;
      }
      try {
        await this.$http
          .post(
            `${process.env.VUE_APP_MONITOR_API}/api/org/finding/${this.currentFindingId}/type/${type}/update`,
            payload
          )
          .then(async (result: any) => {

            toast.info(`Updated`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: "button",
              icon: true,
            });
            if (type === 4) {
              this.presentFindingObject.statusCode = payload.updatedStatus;
            } else if (type == 5) {
              this.presentFindingObject.assignee = payload.assignee;
            }
            await this.getPresentFindingObject();
            await this.getFindingHistoryObject();
          });
      } catch (e:any){
        if(e.response.status==403){
              toast.error(`${e.response.data.error}`, {
              timeout: 1000,
              closeOnClick: true,
              closeButton: 'button',
              icon: true
            });
          }
        else {
          toast.error(`Error`, {
          timeout: 1000,
          closeOnClick: true,
          closeButton: "button",
          icon: true,
        });
        }
      } finally {
				this.clickOnButton = false;
        this.clickOnButtonForCause = false;
      }
      this.presentFindingObject.statusCode = payload.updatedStatus;
    },
    colorFindingText(status: any) {
      if (status == 10401) {
        return ["font-semibold text-disabledgrey"];
      } else if (status == 10421) {
        return ["font-semibold text-yellow"];
      } else if (status == 10403) {
        return ["font-semibold text-lightgreen"];
      } else if (status == 10402) {
        return ["font-semibold mx-2 text-electricGreen"];
      } else if (status == 10406 || status == 10408) {
        return ["font-semibold mx-2 text-primary"];
      } else if (status == 10417) {
        return ["font-semibold mx-2 text-darkred"];
      }else if(status == 10414){
        return ['font-semibold mx-2 text-forReview']
      } else if (status == 10418) {
        return ['font-semibold mx-2 text-error'];
      } 
    },
    colorFindingBg(status: any) {
      if (status == 10401) {
        return ["bgDisabledGrey border-solid border border-disabledgrey"];
      } else if (status == 10421 || status == 10415 || status == 10421) {
        return ["bgYellow border-solid border border-yellow"];
      } else if (status == 10403) {
        return ["bgLightGreen border-solid border border-lightgreen"];
      } else if (status == 10402) {
        return ["bgElectricGreen border-solid border border-electricGreen"];
      } else if (status == 10406 || status == 10408) {
        return ["bgPrimary border-solid border border-primary"];
      } else if (status == 10417) {
        return ["bgdarkred border-solid border border-darkred"];
      }else if (status == 10414 || status == 10419) {
        return ['bgForReview border-solid border border-forReview'];
      }else if (status == 10418) {
        return ['bgError border-solid border border-error'];
      }
    },
    addTextarea() {
      this.v$.$reset();
      this.textareas.push({ action: "",targetDate:"" });
    },
    cancelCauseAction() {
      // this.causeAndActionSaved = false;
      this.causeObjectDummy = { ...this.causeActionObj };
      this.v$.$reset();
      (this.causeActionObj.cause = ""), (this.causeActionObj.actions = []);
      this.textareas = [{ action: "" ,targetDate:""}];
      //   Reset to initial state with one textarea
    },
    save() {
      this.causeActionObj.actions = [...this.textareas];
      // Optionally, you can perform further actions like sending data to backend or resetting form state
    },
    clickedOnDeleteButton(index: number) {
      this.textareas.splice(index, 1);
    },
  },
  async mounted(){
        emitter.off('addedComments');
        emitter.on('addedComments',(data: any)=>{
            this.comment = data.comments
            this.addComment()
        })
       
    },
     beforeUnmount() {
		 sessionStorage.removeItem('selectedTab')
    },
  async created() {
     const savedTabKey = sessionStorage.getItem('selectedTab');
		if (savedTabKey) {
        const savedTab = this.tabHead.find((tab: any) => tab.id == savedTabKey);
        if (savedTab) {
			      this.toggleTabs(savedTab);
        }
		else{
          this.selectedTabObj = this.tabHead.find(
            (tab: any) => tab.id === this.selectedTabIndex
        );
		}
    }
	else{
	   this.selectedTabObj = this.tabHead.find(
        (tab: any) => tab.id === this.selectedTabIndex
    );
	}
    this.tabDataLoading = true
    await this.getFindingsStatuses()
    await this.getallUsers();
    await this.getAllTeams();
    await this.getallEntities();
    this.causeActionObjDummy = { ...this.causeActionObj };
    //  this.textareasDummy = {...this.textareas}
    //  this.textareasDummyForActions = {...this.textareasDummy}
    await this.getPresentFindingObject();
    this.tabDataLoading = false
    // await this.updateFindingPresentStatus(this.currentFindingId)
    await this.getFindingHistoryObject();
    this.titleLength = this.presentFindingObject.finding ? this.presentFindingObject.finding.length:0
    this.teamOwnerName = this.presentFindingObject.reviewer;
    
    // this.selectedTabObj = this.tabHead.find(
    //   (tab: any) => tab.id === this.selectedTabIndex
    // );
    this.routesArray = [
      { name: 'Findings', routeName: "complianceFindings" },
      { name: String(this.presentFindingObject.findingId).toUpperCase(), routeName: "findings" },
    ];
    if (
      this.presentFindingObject.causes == null ||
      this.presentFindingObject.causes == undefined
    ) {
      this.disableSendApprovalButton = true;
    }
    if (this.presentFindingObject.comments != undefined) {
      this.presentFindingObject.comments.sort().reverse();
    }

     if(this.presentFindingObject.assignee != undefined ){
          this.newAssignee = this.presentFindingObject.assignee
      }

  },
});
</script>